<template>
      <!--<section class="new-check-card">
        <div class="new-check-header">
          <div>
            <h1>Nuovo check manuale</h1>
            <p class="new-check-subtitle">Carica foto e misure senza lasciare questa pagina.</p>
          </div>
          <button type="button" class="new-check-toggle" @click="toggleCreate">
            {{ showCreate ? 'Chiudi modulo' : 'Apri modulo' }}
          </button>
        </div>
        <p v-if="userWarning" class="new-check-warning">{{ userWarning }}</p>
        <div v-if="showCreate" class="new-check-form">
          <div class="new-check-section">
            <h3>Foto</h3>
            <div class="photo-upload-grid">
              <div
                v-for="slot in createPhotoSlots"
                :key="slot.key"
                class="photo-upload-box"
                :class="{ 'is-hovered': isDropZoneHovered(newDropZoneKey(slot.key)) }"
                @dragenter.prevent="onNewPhotoDragEnter(slot.key)"
                @dragover.prevent="onNewPhotoDragOver"
                @dragleave.prevent="onNewPhotoDragLeave(slot.key)"
                @drop.prevent="onNewPhotoDrop(slot.key, $event)"
              >
                <template v-if="slot.previewRef.value">
                  <img :src="slot.previewRef.value" :alt="slot.label" class="photo-preview-img" />
                  <div class="photo-actions">
                    <button
                      type="button"
                      class="new-check-action ghost"
                      @click="triggerNewPhotoInput(slot.key)"
                    >
                      Cambia foto
                    </button>
                    <button
                      type="button"
                      class="new-check-action ghost"
                      @click="removeNewPhoto(slot.key)"
                    >
                      Rimuovi
                    </button>
                  </div>
                </template>
                <template v-else>
                  <span class="photo-upload-label">{{ slot.label }}</span>
                  <p class="photo-upload-hint">Trascina qui la foto</p>
                  <span class="photo-upload-or">oppure</span>
                  <button
                    type="button"
                    class="new-check-action primary"
                    @click="triggerNewPhotoInput(slot.key)"
                  >
                    Carica
                  </button>
                </template>
                <input
                  type="file"
                  class="photo-hidden-input"
                  :ref="slot.inputRef"
                  accept="image/jpeg,image/png,image/jpg"
                  @change="onNewPhotoChange(slot.key, $event)"
                  hidden
                />
              </div>
            </div>
          </div>

          <div class="new-check-section">
            <h3>Misurazioni</h3>
            <div class="measurement-textareas">
              <div>
                <label for="new-measurement-one">Misurazione 1</label>
                <textarea
                  id="new-measurement-one"
                  v-model="newMeasurementOneRaw"
                  placeholder="Caratteristica  Valore  Data&#10;Peso  66  06-08-2024"
                ></textarea>
              </div>
              <div>
                <label for="new-measurement-two">Misurazione 2</label>
                <textarea
                  id="new-measurement-two"
                  v-model="newMeasurementTwoRaw"
                  placeholder="Caratteristica  Valore  Data&#10;Peso  64  15-10-2024"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="new-check-section">
            <h3>Dettagli</h3>
            <div class="new-check-fields">
              <div class="field">
                <label for="new-check-type">Tipo check</label>
                <select id="new-check-type" v-model="newCheckType">
                  <option value="baseline">Dati iniziali (baseline)</option>
                  <option value="progress">Check di andamento</option>
                </select>
              </div>
              <div class="field">
                <label for="new-percorso">Programma collegato (opzionale)</label>
                <select id="new-percorso" v-model="newPercorsoId">
                  <option value="">— Nessun programma —</option>
                  <option v-for="perc in percorsi" :key="perc.id" :value="perc.id">
                    {{ renderPercorsoLabel(perc) }}
                  </option>
                </select>
              </div>
              <div class="field checkbox-field">
                <label>
                  <input type="checkbox" v-model="newVisibilityProfile" />
                  Visibile nel profilo utente
                </label>
              </div>
              <div class="field">
                <label for="new-check-text">Commento</label>
                <textarea
                  id="new-check-text"
                  v-model="newCheckText"
                  placeholder="Note o commento sul check"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="new-check-actions">
            <button type="button" class="new-check-action ghost" @click="resetCreateForm" :disabled="createSaving">
              Reset
            </button>
            <button type="button" class="new-check-action primary" @click="saveManualCheck" :disabled="createSaving">
              {{ createSaving ? 'Salvataggio…' : 'Salva check' }}
            </button>
          </div>
        </div>
      </section>-->

      <!-- Nuova sezione: Check Dafare per questo utente -->
      <div class="titolo-card" style="margin-top: 2rem;">
        <h1>Check Da fare Utente</h1>
      </div>
      <div class="checks-list">
        <div v-if="sortedDafareChecks.length">
          <table class="user-dafare-table">
            <thead>
              <tr>
                <th>Data Creazione</th>
                <th>Data Consegna</th>
                <th>Stato</th>
                <th>Note Check</th>
                <th>Email Assegnata</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in sortedDafareChecks" :key="c.id">
                <td>{{ formatDateTime(c.createdAt) }}</td>
                <td>{{ formatDate(c.dataConsegna) }}</td>
<td class="col-stato">
  <select
    v-model="c.fatto"
    @change="updateDafareCheckField(c.id, 'fatto', c.fatto)"
    class="text-input"
  >
    <option value="da fare">da fare</option>
    <option value="si">fatto</option>
  </select>
</td>
                <td>{{ c.notedelcheck }}</td>
                <td>{{ c.assignedEmail }}</td>
              </tr>
            </tbody>
          </table>
      </div>
      <div v-else>
        <p>Nessun checkdafare trovato per questo utente.</p>
      </div>
      </div>

      <div class="titolo-card">
        <h1>Visibilita utente</h1>
      </div>
      <div class="checks-list">
        <div class="visibility-card">
          <div class="visibility-card__content">
            <span class="visibility-card__eyebrow">Privacy check</span>
            <h3>Nascondi confronti e storico</h3>
            <p>
              Quando attivo, l'utente non vedra comparazioni e check storici nel proprio profilo.
            </p>
            <div class="visibility-card__status">
              <span :class="hideChecksFromUser ? 'status-pill status-pill--off' : 'status-pill status-pill--on'">
                {{ hideChecksFromUser ? 'Nascosto' : 'Visibile' }}
              </span>
              <span v-if="hideChecksSaving" class="status-loading">Salvataggio...</span>
            </div>
          </div>
          <label class="switch" aria-label="Nascondi confronti e storico nel profilo utente">
            <input
              type="checkbox"
              v-model="hideChecksFromUser"
              :disabled="hideChecksSaving"
              @change="updateUserChecksVisibility"
            />
            <span class="switch__track"></span>
            <span class="switch__thumb"></span>
          </label>
        </div>
      </div>


      <div class="titolo-card">
        <h1>Andamento</h1>
      </div>

      <div class="trend-section">
        <div v-if="!trendCharts.length">
          <p class="muted">Nessun dato disponibile per mostrare l'andamento.</p>
        </div>
        <div v-else class="trend-grid">
          <div
            v-for="chart in trendCharts"
            :key="chart.label"
            class="trend-card"
          >
            <div class="trend-card__head">
              <div>
                <h3>{{ chart.label }}</h3>
                <small class="muted">Ultimo valore: {{ chart.latestLabel }}</small>
              </div>
              <span class="trend-diff" :class="chart.deltaClass">{{ chart.deltaLabel }}</span>
            </div>
            <div class="trend-chart">
              <svg viewBox="0 0 100 100" preserveAspectRatio="none">
                <polyline
                  :points="chart.polyline"
                  :stroke="chart.color"
                  fill="none"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <circle
                  v-for="(point, idx) in chart.points"
                  :key="`${chart.label}_pt_${idx}`"
                  :cx="point.x"
                  :cy="point.y"
                  r="1.8"
                  :fill="point.kindClass === 'initial' ? '#0ea5e9' : chart.color"
                  :stroke="point.kindClass === 'initial' ? chart.color : '#0ea5e9'"
                  stroke-width="0.6"
                />
              </svg>
            </div>
            <ul class="trend-points">
              <li v-for="(point, idx) in chart.points" :key="`${chart.label}_lbl_${idx}`">
                <span class="trend-kind" :class="`trend-kind--${point.kindClass}`">{{ point.kindLabel }}</span>
                <span class="trend-date">{{ point.dateLabel }}</span>
                <span class="trend-value">{{ point.valueLabel }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div class="titolo-card">
        <h1>Comparazioni Questionari</h1>
      </div>

      <div class="checks-list comparison-section">
        <div v-if="comparisonsLoading">
          <p>Carico le comparazioni…</p>
        </div>
        <div v-else-if="comparisonsError">
          <p class="error-text">Errore: {{ comparisonsError }}</p>
        </div>
        <div v-else-if="!comparisonChecks.length">
          <p>Nessuna comparazione disponibile.</p>
        </div>
        <div v-else>
          <div
            v-for="check in comparisonChecks"
            :key="`cmp_${check.id}`"
            class="comparison-card"
          >
            <div class="comparison-head">
              <div>
                <h3>Check {{ check.id }}</h3>
                <p class="muted">Percorso: {{ check.percorsoId || '—' }}</p>
              </div>
              <div class="comparison-meta">
                <span>{{ formatDateTime(check.createdAt) || '—' }}</span>
                <span v-if="check.stepIndex != null">Step #{{ check.stepIndex + 1 }}</span>
              </div>
            </div>

            <div v-if="hasPhotoComparison(check)" class="comparison-photos">
              <div
                v-for="photo in photoComparisonsFor(check)"
                :key="photo.key || photo.label"
                class="photo-comparison"
              >
                <h4>{{ photo.label }}</h4>
                <div class="photo-columns">
                  <div class="photo-col photo-col--initial">
                    <div class="photo-col-title">Questionario iniziale</div>
                    <template v-if="photo.initialUrls.length">
                      <img
                        v-for="url in photo.initialUrls"
                        :key="url"
                        class="photo-col-img"
                        :src="url"
                        :alt="`${photo.label} questionario iniziale`"
                      />
                    </template>
                    <div v-else class="photo-empty">
                      <button
                        type="button"
                        class="questionnaire-link"
                        @click="openInitialQuestionnaire(check)"
                      >
                        Clicca qui per caricare foto e misure dal questionario iniziale
                      </button>
                    </div>
                  </div>
                  <div class="photo-col">
                    <div class="photo-col-title">Check</div>
                    <template v-if="photo.checkUrls.length">
                      <img
                        v-for="url in photo.checkUrls"
                        :key="url"
                        :src="url"
                        :alt="`${photo.label} check`"
                      />
                    </template>
                    <div v-else class="photo-empty">—</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="comparison-placeholder">
              <button
                type="button"
                class="questionnaire-link"
                @click="openInitialQuestionnaire(check)"
              >
                Clicca qui per caricare foto e misure dal questionario iniziale
              </button>
            </div>

            <div v-if="hasMeasurements(check)" class="comparison-measurements">
              <table>
                <thead>
                  <tr>
                    <th>Misura</th>
                    <th>
                      <span>Questionario iniziale</span>
                      <button
                        v-if="supportsInitialDataEdits(check)"
                        type="button"
                        class="table-action-link"
                        @click="initialMeasurementEditors[check.id] ? closeInitialMeasurementEditor(check.id) : openInitialMeasurementEditor(check)"
                        :disabled="initialMeasurementEditors[check.id]?.saving"
                      >
                        {{ initialMeasurementEditors[check.id] ? 'Chiudi' : 'Inserisci' }}
                      </button>
                    </th>
                    <th>Check</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in measurementComparisonsFor(check)" :key="`meas_${row.label}`">
                    <td>{{ row.label }}</td>
                    <td>
                      <div>{{ formatMeasurement(row.initialValue) }}</div>
                      <small v-if="row.initialDate" class="muted">{{ row.initialDate }}</small>
                    </td>
                    <td>
                      <div>{{ formatMeasurement(row.checkValue) }}</div>
                      <small v-if="row.checkDate" class="muted">{{ row.checkDate }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                v-if="initialMeasurementEditors[check.id]"
                class="measurement-editor measurement-editor--initial"
              >
                <label for="initial-measurements">Misure questionario iniziale</label>
                <textarea
                  id="initial-measurements"
                  v-model="initialMeasurementEditors[check.id].text"
                  placeholder="Caratteristica  Valore  Data&#10;Peso (kg)  66  06-08-2024"
                ></textarea>
                <p class="measurement-hint">Esempio: <code>Peso (kg)  66  06-08-2024</code>. Puoi incollare più righe; l'intestazione viene ignorata.</p>
                <p class="measurement-hint">Esempio: <code>Peso (kg)  66  06-08-2024</code>. Puoi incollare più righe, l'intestazione verrà ignorata.</p>
                <div class="measurement-editor-actions">
                  <button
                    type="button"
                    class="new-check-action ghost staff-button-cancel"
                    @click="closeInitialMeasurementEditor(check.id)"
                    :disabled="initialMeasurementEditors[check.id].saving"
                  >
                    Annulla
                  </button>
                  <button
                    type="button"
                    class="new-check-action primary staff-button-positive"
                    @click="saveInitialMeasurementEditor(check)"
                    :disabled="initialMeasurementEditors[check.id].saving"
                  >
                    {{ initialMeasurementEditors[check.id].saving ? 'Salvataggio…' : 'Salva misure' }}
                  </button>
                </div>
              </div>
              <div
                v-if="!hasInitialMeasurements(check)"
                class="comparison-placeholder comparison-placeholder--inner"
              >
                <button
                  type="button"
                  class="questionnaire-link"
                  @click="openInitialQuestionnaire(check)"
                >
                  Clicca qui per caricare foto e misure dal questionario iniziale
                </button>
              </div>
            </div>
            <div v-else class="comparison-placeholder">
              <button
                type="button"
                class="questionnaire-link"
                @click="openInitialQuestionnaire(check)"
              >
                Clicca qui per caricare foto e misure dal questionario iniziale
              </button>
            </div>
          </div>
        </div>
      </div>

      
            <!-- Titolo storico -->
      <div class="titolo-card">
        <h1>Check storici</h1>
      </div>

      <!-- Sezione storica originale -->
      <div class="checks-list" style="margin-top: 2rem;">
        <div v-if="checksLoading">
          <p>Caricamento check…</p>
        </div>
        <div v-else-if="checksError">
          <p class="error-text">Errore: {{ checksError }}</p>
        </div>
        <div v-else-if="manualHistoryChecks.length">
          <div
            v-for="check in manualHistoryChecks"
            :key="check.id"
            class="check-card"
          >
            <h3>Check ID: {{ check.id }}</h3>
            <p><strong>Data creazione:</strong> {{ formatDate(check.createdAt) }}</p>
            <p>
              <strong>Origine:</strong>
              <span class="tag" :class="check.creationMode === 'automatic' ? 'tag-auto' : 'tag-manual'">
                {{ check.creationMode === 'automatic' ? 'Automatico' : 'Manuale' }}
              </span>
              <span v-if="check.linkedQuestionnaireId" class="tag tag-link">
                questionario: {{ check.linkedQuestionnaireId }}
              </span>
            </p>
            <p class="check-approval">
              <strong>Stato approvazione:</strong>
              <span class="tag" :class="check.approved ? 'tag-approved' : 'tag-pending'">
                {{ check.approved ? 'Approvato' : 'Da approvare' }}
              </span>
              <small v-if="check.approvedAt" class="muted">
                Aggiornato {{ formatDateTime(check.approvedAt) }}
              </small>
            </p>
            <div class="approval-actions">
              <button
                type="button"
                class="new-check-action primary"
                @click="toggleCheckApproval(check)"
                :disabled="isCheckApprovalSaving(check.id)"
              >
                {{ isCheckApprovalSaving(check.id) ? 'Salvataggio…' : check.approved ? 'Revoca approvazione' : 'Approva check' }}
              </button>
            </div>
           <!-- <p>
              <strong>Visibilità profilo:</strong>
              {{ check.visibilityProfile ? 'Visibile' : 'Non visibile' }}
            </p>
            <div class="select-details">
              <p><strong>Utente:</strong> {{ check.gender }}</p>
              <p><strong>Età:</strong> {{ check.ageGroup }}</p>
              <p><strong>Menopausa:</strong> {{ check.menopausa }}</p>
              <p><strong>Ha seguito:</strong> {{ check.haSeguito }}</p>
              <p><strong>Tipo di percorso:</strong> {{ check.tipoPercorso }}</p>
              <p><strong>Progressi:</strong> {{ check.haAvutoProgressi }}</p>
              <p><strong>Allenamento rispettato:</strong> {{ check.respectAllenamento }}</p>
              <p><strong>Nutrizione rispettata:</strong> {{ check.respectNutrizione }}</p>
              <p><strong>Acqua (L):</strong> {{ check.acquaAssunta }}</p>
              <p><strong>Riposo:</strong> {{ check.riposoCorretta }}</p>
              <p><strong>Stress:</strong> {{ check.periodoStressante }}</p>
              <p><strong>Integrazione:</strong> {{ check.integrazione }}</p>
            </div>
-->
            
            <!-- Testo e Foto -->
            <div class="text-photos">
              <p><strong>Commento:</strong></p>
              <p class="check-text">{{ check.text }}</p>
              <div class="photo-pairs">
                <div
                  v-for="pair in manualPhotoPairs"
                  :key="`${check.id}_${pair.key}`"
                  class="photo-pair"
                >
                  <div class="photo-pair__title">{{ pair.label }}</div>
                  <div class="photo-pair__columns">
                    <div
                      v-for="slot in pair.columns"
                      :key="`${check.id}_${slot.key}`"
                      class="photo-slot"
                      :class="{ 'is-hovered': isDropZoneHovered(existingDropZoneKey(check.id, slot.key)) }"
                      @dragenter.prevent="onExistingPhotoDragEnter(check.id, slot.key)"
                      @dragover.prevent="onExistingPhotoDragOver"
                      @dragleave.prevent="onExistingPhotoDragLeave(check.id, slot.key)"
                      @drop.prevent="onExistingPhotoDrop(check, slot.key, $event)"
                    >
                      <template v-if="check[slot.field]">
                        <img :src="check[slot.field]" :alt="slot.label" class="photo-slot-img" />
                        <small class="photo-slot-label">{{ slot.columnLabel }}</small>
                      </template>
                      <template v-else>
                        <span class="photo-slot-label">{{ slot.columnLabel }}</span>
                        <p class="photo-upload-hint">Trascina qui la foto</p>
                        <span class="photo-upload-or">oppure</span>
                        <label class="photo-upload-button">
                          Carica
                          <input
                            type="file"
                            accept="image/jpeg,image/png,image/jpg"
                            @change="handleExistingPhotoUpload(check, slot.key, $event)"
                          />
                        </label>
                        <span
                          v-if="isPhotoUploading(check.id, slot.key)"
                          class="photo-loading"
                        >
                          Caricamento…
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Misurazioni -->
            <div class="measurements-wrapper">
              <div
                class="measurements"
                v-if="(check.measurementsOne && check.measurementsOne.length) ||
                      (check.measurementsTwo && check.measurementsTwo.length)"
              >
                <div v-if="check.measurementsOne && check.measurementsOne.length">
                  <h4>Misurazione 1</h4>
                  <table>
                    <thead>
                      <tr>
                        <th>Caratteristica</th>
                        <th>Valore</th>
                        <th>Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(m, i) in check.measurementsOne" :key="`m1_${i}`">
                        <td>{{ m.caratteristica }}</td>
                        <td>{{ m.valore }}</td>
                        <td>{{ m.data }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="check.measurementsTwo && check.measurementsTwo.length">
                  <h4>Misurazione 2</h4>
                  <table>
                    <thead>
                      <tr>
                        <th>Caratteristica</th>
                        <th>Valore</th>
                        <th>Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(m, i) in check.measurementsTwo" :key="`m2_${i}`">
                        <td>{{ m.caratteristica }}</td>
                        <td>{{ m.valore }}</td>
                        <td>{{ m.data }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="measurement-edit-actions">
                <button :class="measurementEditors[check.id] ? 'staff-button-cancel' : 'staff-button-positive'"
                  type="button"
                  class="new-check-action ghost"
                  @click="measurementEditors[check.id] ? closeMeasurementEditor(check.id) : openMeasurementEditor(check)"
                >
                  {{ measurementEditors[check.id] ? 'Chiudi inserimento misure' : 'Inserisci/Modifica misure' }}
                </button>
              </div>

              <div
                v-if="measurementEditors[check.id]"
                class="measurement-editor"
              >
                <div class="measurement-editor-grid">
                  <div>
                    <label>Misurazione 1</label>
                    <textarea v-model="measurementEditors[check.id].m1"></textarea>
                    <p class="measurement-hint">Formato: <code>Caratteristica  Valore  Data</code> (es. <code>Peso (kg)  66  06-08-2024</code>).</p>
                  </div>
                  <div>
                    <label>Misurazione 2</label>
                    <textarea v-model="measurementEditors[check.id].m2"></textarea>
                    <p class="measurement-hint">Lascia vuoto se non vuoi registrare la seconda misurazione.</p>
                  </div>
                </div>
                <div class="measurement-editor-actions">
                  <button
                    type="button"
                    class="new-check-action ghost staff-button-cancel"
                    @click="closeMeasurementEditor(check.id)"
                    :disabled="measurementEditors[check.id].saving"
                  >
                    Annulla
                  </button>
                  <button
                    type="button"
                    class="new-check-action primary staff-button-positive"
                    @click="saveMeasurementEditor(check)"
                    :disabled="measurementEditors[check.id].saving"
                  >
                    {{ measurementEditors[check.id].saving ? 'Salvataggio…' : 'Salva misure' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <p>Nessun check salvato per questo utente.</p>
        </div>
      </div>
</template>



<script>
import { ref, watch, onBeforeUnmount, computed, reactive } from 'vue';
import { useRouter } from 'vue-router';
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  updateDoc,
  setDoc,
  doc,
  getDoc,
  addDoc,
  serverTimestamp
} from 'firebase/firestore';
import { getStorage, ref as storageRef, getDownloadURL, uploadBytes } from 'firebase/storage';

function toDate(value) {
  if (!value) return null;
  if (value.toDate && typeof value.toDate === 'function') {
    try {
      const date = value.toDate();
      return Number.isNaN(date?.getTime?.()) ? null : date;
    } catch (err) {
      return null;
    }
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function formatMeasurement(value) {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'number') {
    const abs = Math.abs(value);
    const precision = abs >= 10 ? 1 : 2;
    const fixed = value.toFixed(precision);
    const asNumber = Number(fixed);
    if (Number.isInteger(asNumber)) return String(asNumber);
    return fixed.replace('.', ',');
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length ? trimmed : '—';
  }
  return String(value);
}

const INITIAL_MEASUREMENT_FIELDS = [
  { key: 'peso', label: 'Peso (kg)', aliases: ['peso_attuale', 'peso_check'] },
  { key: 'altezza', label: 'Altezza (cm)' },
  { key: 'fianchi', label: 'Fianchi (cm)', aliases: ['circonferenza_fianchi', 'fianchi_cm'] },
  { key: 'coscia', label: 'Coscia (cm)' },
  { key: 'addome', label: 'Addome (cm)', aliases: ['circonferenza_vita', 'vita'] },
  { key: 'torace', label: 'Torace (cm)' },
  { key: 'braccio', label: 'Braccio (cm)' },
  { key: 'massa_magra', label: 'Massa magra (%)', aliases: ['massaMagra'] },
  { key: 'massa_grassa', label: 'Massa grassa (%)', aliases: ['massaGrassa'] },
  { key: 'acqua_corporea', label: 'Acqua corporea (%)', aliases: ['acquaCorporea'] }
];

const CHECK_MEASUREMENT_FIELDS = [
  { key: 'peso_attuale', label: 'Peso (kg)', aliases: ['peso'] },
  { key: 'altezza', label: 'Altezza (cm)' },
  { key: 'circonferenza_vita', label: 'Vita (cm)', aliases: ['vita', 'addome'] },
  { key: 'circonferenza_fianchi', label: 'Fianchi (cm)', aliases: ['fianchi'] },
  { key: 'coscia', label: 'Coscia (cm)' },
  { key: 'addome', label: 'Addome (cm)', aliases: ['vita'] },
  { key: 'torace', label: 'Torace (cm)' },
  { key: 'braccio', label: 'Braccio (cm)' },
  { key: 'massa_magra', label: 'Massa magra (%)', aliases: ['massaMagra'] },
  { key: 'massa_grassa', label: 'Massa grassa (%)', aliases: ['massaGrassa'] },
  { key: 'acqua_corporea', label: 'Acqua corporea (%)', aliases: ['acquaCorporea'] }
];

const hasBaselineData = (doc) => {
  if (!doc) return false;
  const answers = doc.answers || {};
  const foto = answers.foto || {};
  const hasPhotos = Object.values(foto).some((entry) => {
    if (!entry) return false;
    if (typeof entry === 'string') return entry.trim().length > 0;
    if (typeof entry === 'object') {
      return !!(entry.path || entry.url || entry.name);
    }
    return false;
  });
  const hasMeasurements = INITIAL_MEASUREMENT_FIELDS.some((field) => {
    const keys = [field.key, ...(field.aliases || [])];
    return keys.some((key) => {
      const value = valueFromAnswer(answers, key);
      if (value === null || value === undefined) return false;
      if (typeof value === 'string') return value.trim().length > 0;
      if (typeof value === 'number') return Number.isFinite(value);
      return true;
    });
  });
  return hasPhotos || hasMeasurements;
};

const questionnaireGroupKey = (row) => {
  if (!row || typeof row !== 'object') return `__${Math.random().toString(36).slice(2)}`;
  return (
    row.sequenceGroupId ||
    row.percorsoId ||
    `__${row.id || Math.random().toString(36).slice(2)}`
  );
};

const TREND_CONFIGS = [
  { label: 'Peso (kg)', color: '#2563eb', unit: 'kg' },
  { label: 'Vita (cm)', color: '#ec4899', unit: 'cm' },
  { label: 'Fianchi (cm)', color: '#f97316', unit: 'cm' },
  { label: 'Massa grassa (%)', color: '#22c55e', unit: '%' }
];

const PHOTO_FIELD_MAP = [
  {
    key: 'foto_frontale',
    label: 'Foto frontale',
    answerKeys: ['foto_frontale'],
    answerPaths: [
      ['foto_frontale'],
      ['foto', 'anteriore'],
      ['foto', 'frontale']
    ],
    initialKeys: ['foto_frontale'],
    initialPaths: [
      ['foto_frontale'],
      ['foto', 'anteriore'],
      ['foto', 'frontale']
    ],
    isPrimary: true
  },
  {
    key: 'foto_posteriore',
    label: 'Foto posteriore',
    answerKeys: ['foto_posteriore'],
    answerPaths: [
      ['foto_posteriore'],
      ['foto', 'posteriore'],
      ['foto', 'retro']
    ],
    initialKeys: ['foto_posteriore'],
    initialPaths: [
      ['foto_posteriore'],
      ['foto', 'posteriore'],
      ['foto', 'retro']
    ],
    isPrimary: true
  },
  {
    key: 'foto_lato_sinistro',
    label: 'Foto lato sinistro',
    answerKeys: ['foto_lato_sinistro', 'foto_laterale'],
    answerPaths: [
      ['foto_lato_sinistro'],
      ['foto', 'profiloSinistro'],
      ['foto', 'profiloSinistra'],
      ['foto', 'lateraleSinistro'],
      ['foto', 'lateraleSinistra']
    ],
    initialKeys: ['foto_lato_sinistro', 'foto_laterale_sinistra', 'foto_laterale'],
    initialPaths: [
      ['foto_lato_sinistro'],
      ['foto', 'profiloSinistro'],
      ['foto', 'profiloSinistra'],
      ['foto', 'lateraleSinistro'],
      ['foto', 'lateraleSinistra']
    ],
    isPrimary: false
  },
  {
    key: 'foto_lato_destro',
    label: 'Foto lato destro',
    answerKeys: ['foto_lato_destro', 'foto_extra'],
    answerPaths: [
      ['foto_lato_destro'],
      ['foto', 'profiloDestro'],
      ['foto', 'profiloDestra'],
      ['foto', 'lateraleDestro'],
      ['foto', 'lateraleDestra']
    ],
    initialKeys: ['foto_lato_destro', 'foto_laterale_destra', 'foto_extra'],
    initialPaths: [
      ['foto_lato_destro'],
      ['foto', 'profiloDestro'],
      ['foto', 'profiloDestra'],
      ['foto', 'lateraleDestro'],
      ['foto', 'lateraleDestra']
    ],
    isPrimary: false
  }
];

const metaValueAtPath = (source, path = []) => {
  if (!source || typeof source !== 'object' || !Array.isArray(path) || !path.length) {
    return null;
  }
  let current = source;
  for (const segment of path) {
    if (current && typeof current === 'object' && segment in current) {
      current = current[segment];
    } else {
      return null;
    }
  }
  return current;
};

const normalizeMetaList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.flatMap(item => normalizeMetaList(item));
  }
  if (value && typeof value === 'object') {
    if (Array.isArray(value.files)) {
      return normalizeMetaList(value.files);
    }
    return [value];
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];
    if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('gs://')) {
      return [{ url: trimmed }];
    }
    return [{ path: trimmed }];
  }
  return [];
};

const collectPhotoMetas = (answers, keys = [], paths = []) => {
  if (!answers || typeof answers !== 'object') return [];
  const metas = [];
  const pushValue = (raw) => {
    normalizeMetaList(raw).forEach(meta => {
      if (meta && typeof meta === 'object') metas.push(meta);
    });
  };

  keys.forEach((key) => {
    if (!key) return;
    const raw = answers[key];
    if (!raw) return;
    if (raw && typeof raw === 'object' && Array.isArray(raw.files)) {
      pushValue(raw.files);
    } else {
      pushValue(raw);
    }
  });

  paths.forEach((path) => {
    if (!Array.isArray(path) || !path.length) return;
    const raw = metaValueAtPath(answers, path);
    if (!raw) return;
    if (raw && typeof raw === 'object' && Array.isArray(raw.files)) {
      pushValue(raw.files);
    } else {
      pushValue(raw);
    }
  });

  return metas;
};

const toOptionalNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const CHECK_PHOTO_SLOTS = [
  { key: 'front_before', label: 'Foto 1 (frontale)', field: 'imageOneUrl' },
  { key: 'front_after', label: 'Foto 2 (frontale)', field: 'imageTwoUrl' },
  { key: 'back_before', label: 'Foto 3 (posteriore)', field: 'imageThreeUrl' },
  { key: 'back_after', label: 'Foto 4 (posteriore)', field: 'imageFourUrl' }
];

const MANUAL_PHOTO_PAIRS = [
  {
    key: 'front',
    label: 'Foto frontale',
    slots: [
      { slotKey: 'front_before', columnLabel: 'Foto 1' },
      { slotKey: 'front_after', columnLabel: 'Foto 2' }
    ]
  },
  {
    key: 'back',
    label: 'Foto posteriore',
    slots: [
      { slotKey: 'back_before', columnLabel: 'Foto 3' },
      { slotKey: 'back_after', columnLabel: 'Foto 4' }
    ]
  }
];

function formatMeasurementValue(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') {
    const str = Number.isInteger(value) ? String(value) : value.toFixed(2);
    return str.replace('.', ',');
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length ? trimmed : null;
  }
  return String(value);
}

function valueFromAnswer(answers, key) {
  if (!answers || !key || typeof answers !== 'object') return null;
  const raw = answers[key];
  if (raw === undefined || raw === null) return null;
  if (raw && typeof raw === 'object' && Array.isArray(raw.files)) return null;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    return trimmed.length ? trimmed : null;
  }
  return raw;
}

export default {
  name: 'UserCheck',
  props: {
    userId: { type: String, required: true }
  },
  setup(props) {
    const checks = ref([]);
    const dafareChecks = ref([]);
    const checksError = ref('');
    const checksLoading = ref(false);
    const db = getFirestore();
    const storage = getStorage();
    const fileUrlCache = new Map();
    const router = useRouter();
    const questionnaireComparisons = ref([]);
    const questionnaireDocs = ref([]);
    const questionnaireLoading = ref(false);
    const questionnaireError = ref('');

    const showCreate = ref(false);
    const createSaving = ref(false);
    const newCheckText = ref('');
    const newMeasurementOneRaw = ref('');
    const newMeasurementTwoRaw = ref('');
    const newCheckType = ref('baseline');
    const newPercorsoId = ref('');
    const newVisibilityProfile = ref(true);
    const hideChecksFromUser = ref(false);
    const hideChecksSaving = ref(false);
    const photoRefsMap = CHECK_PHOTO_SLOTS.reduce((acc, slot) => {
      acc[slot.key] = {
        fileRef: ref(null),
        previewRef: ref(''),
        inputRef: ref(null)
      };
      return acc;
    }, {});
    const userWarning = ref('');
    const percorsi = ref([]);

    const SPECIAL_UID = '6HPQLWIxnGbTVDYPYCkRZifVxRQ2';
    const SPECIAL_WARNING = 'NON CARICARE LE FOTO PER LEI';

    const createPhotoSlots = CHECK_PHOTO_SLOTS.map(slot => ({
      ...slot,
      fileRef: photoRefsMap[slot.key]?.fileRef || ref(null),
      previewRef: photoRefsMap[slot.key]?.previewRef || ref(''),
      inputRef: photoRefsMap[slot.key]?.inputRef || ref(null)
    }));

    const existingPhotoSlots = CHECK_PHOTO_SLOTS;
    const photoSlotByKey = existingPhotoSlots.reduce((acc, slot) => {
      acc[slot.key] = slot;
      return acc;
    }, {});
    const manualPhotoPairs = MANUAL_PHOTO_PAIRS.map(pair => ({
      ...pair,
      columns: pair.slots
        .map(slot => {
          const slotDef = photoSlotByKey[slot.slotKey];
          if (!slotDef) return null;
          return {
            ...slotDef,
            columnLabel: slot.columnLabel
          };
        })
        .filter(Boolean)
    }));

    const photoUploadFlags = reactive({});
    const measurementEditors = reactive({});
    const initialMeasurementEditors = reactive({});
    const approvalSaving = reactive({});

    let unsubscribePercorsi = null;

    let unsubscribeChecks = null;
    let unsubscribeDafare = null;
    let unsubscribeQuestionari = null;

    const hoveredDropZone = ref('');

    const dropZoneKey = (scope, slotKey, extra = '') =>
      `${scope}-${slotKey}${extra ? `-${extra}` : ''}`;

    const isDropZoneHovered = (key) => hoveredDropZone.value === key;

    const setDropZoneHover = (key, active) => {
      if (active) {
        hoveredDropZone.value = key;
      } else if (hoveredDropZone.value === key) {
        hoveredDropZone.value = '';
      }
    };

    const newDropZoneKey = (slotKey) => dropZoneKey('new', slotKey);
    const existingDropZoneKey = (checkId, slotKey) => dropZoneKey('existing', slotKey, checkId);
    const findPhotoSlot = (slotKey) => createPhotoSlots.find(slot => slot.key === slotKey);

    const updatePhotoSlot = (slotKey, file) => {
      const slot = findPhotoSlot(slotKey);
      if (!slot) return;
      if (slot.previewRef.value) {
        URL.revokeObjectURL(slot.previewRef.value);
        slot.previewRef.value = '';
      }
      slot.fileRef.value = file || null;
      if (file) {
        try {
          slot.previewRef.value = URL.createObjectURL(file);
        } catch (err) {
          console.warn('Impossibile generare anteprima immagine:', err);
          slot.previewRef.value = '';
        }
      }
    };

    const sanitizeFileName = (name = '') =>
      name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9._-]/g, '_');

    const onNewPhotoChange = (slotKey, event) => {
      const files = event?.target?.files;
      const file = files && files[0] ? files[0] : null;
      updatePhotoSlot(slotKey, file);
      if (event?.target) {
        event.target.value = '';
      }
    };

    const removeNewPhoto = (slotKey) => {
      const slot = findPhotoSlot(slotKey);
      updatePhotoSlot(slotKey, null);
      if (slot?.inputRef?.value) {
        slot.inputRef.value.value = '';
      }
    };

    const onNewPhotoDragEnter = (slotKey) => {
      setDropZoneHover(dropZoneKey('new', slotKey), true);
    };

    const onNewPhotoDragLeave = (slotKey) => {
      setDropZoneHover(dropZoneKey('new', slotKey), false);
    };

    const onNewPhotoDragOver = (event) => {
      event.preventDefault();
    };

    const onNewPhotoDrop = (slotKey, event) => {
      event.preventDefault();
      setDropZoneHover(dropZoneKey('new', slotKey), false);
      const file = event?.dataTransfer?.files?.[0];
      if (file) {
        updatePhotoSlot(slotKey, file);
      }
    };

    const triggerNewPhotoInput = (slotKey) => {
      const slot = findPhotoSlot(slotKey);
      const inputEl = slot?.inputRef?.value || null;
      if (inputEl) {
        inputEl.click();
      }
    };

    const resetCreateForm = () => {
      newCheckText.value = '';
      newMeasurementOneRaw.value = '';
      newMeasurementTwoRaw.value = '';
      newCheckType.value = 'baseline';
      newPercorsoId.value = '';
      newVisibilityProfile.value = true;
      createPhotoSlots.forEach(slot => updatePhotoSlot(slot.key, null));
      hoveredDropZone.value = '';
    };

    const parseMeasurementData = (rawData) => {
      if (!rawData) return [];
      const lines = rawData
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean);
      const rows = [];
      const pushRow = (caratteristica, valore, data) => {
        const label = (caratteristica || '').trim();
        const val = (valore || '').trim();
        const date = (data || '').trim();
        if (!label || !val) return;
        rows.push({ caratteristica: label, valore: val, data: date });
      };
      for (const line of lines) {
        if (/caratteristica/i.test(line) && /valore/i.test(line) && /data/i.test(line)) continue;
        const parts = line.split(/\s{2,}|\t+/).filter(Boolean);
        if (parts.length >= 3) {
          pushRow(parts[0], parts[1], parts.slice(2).join(' '));
          continue;
        }
        const tokens = line.split(/\s+/).filter(Boolean);
        if (tokens.length >= 3) {
          const data = tokens.pop();
          const valore = tokens.pop();
          const caratteristica = tokens.join(' ');
          pushRow(caratteristica, valore, data);
        }
      }
      return rows;
    };

    const renderPercorsoLabel = (p) => {
      if (!p) return 'Programma';
      const parts = [];
      if (p.title) parts.push(p.title);
      else if (p.productName) parts.push(p.productName);
      else parts.push('Programma');
      if (p.sequenceTotal) {
        parts.push(`#${p.sequenceIndex || 1}/${p.sequenceTotal}`);
      }
      return parts.join(' · ');
    };

    const subscribePercorsi = (uid) => {
      if (unsubscribePercorsi) {
        unsubscribePercorsi();
        unsubscribePercorsi = null;
      }
      percorsi.value = [];
      if (!uid) return;
      try {
        const percorsiQuery = query(
          collection(db, 'percorsi'),
          where('uid', '==', uid)
        );
        unsubscribePercorsi = onSnapshot(
          percorsiQuery,
          (snap) => {
            percorsi.value = snap.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
          },
          (error) => {
            console.error('Errore caricando i percorsi:', error);
            percorsi.value = [];
          }
        );
      } catch (error) {
        console.error('Errore inizializzando i percorsi:', error);
        percorsi.value = [];
      }
    };

    const loadUserWarning = async (uid) => {
      userWarning.value = '';
      hideChecksFromUser.value = false;
      if (!uid) return;
      try {
        const userRef = doc(db, 'users', uid);
        const snapshot = await getDoc(userRef);
        if (snapshot.exists()) {
          const data = snapshot.data();
          hideChecksFromUser.value = data?.hideChecksFromUser === true;
          const warningFields = ['checkWarning', 'checkNotice', 'adminWarning'];
          for (const field of warningFields) {
            const value = data?.[field];
            if (typeof value === 'string' && value.trim()) {
              userWarning.value = value.trim();
              break;
            }
          }
        }
      } catch (error) {
        console.error('Errore caricando l’avviso utente:', error);
      }
      if (!userWarning.value && uid === SPECIAL_UID) {
        userWarning.value = SPECIAL_WARNING;
      }
    };

    const updateUserChecksVisibility = async () => {
      if (!props.userId || hideChecksSaving.value) return;
      const nextValue = hideChecksFromUser.value;
      const fallbackValue = !nextValue;
      hideChecksSaving.value = true;
      try {
        await updateDoc(doc(db, 'users', props.userId), {
          hideChecksFromUser: nextValue
        });
      } catch (error) {
        console.error('Errore aggiornando la visibilita check utente:', error);
        alert("Errore durante l'aggiornamento della visibilita utente.");
        hideChecksFromUser.value = fallbackValue;
      } finally {
        hideChecksSaving.value = false;
      }
    };

    const uploadPhotoFile = async (file, { folder } = {}) => {
      if (!file) return '';
      const safeName = sanitizeFileName(file.name || 'photo.jpg');
      const baseFolder = folder || `check/${props.userId}`;
      const suffix = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      const storagePath = `${baseFolder}/${suffix}_${safeName}`;
      const targetRef = storageRef(storage, storagePath);
      await uploadBytes(targetRef, file);
      const downloadUrl = await getDownloadURL(targetRef);
      fileUrlCache.set(storagePath, downloadUrl);
      return downloadUrl;
    };

    const saveManualCheck = async () => {
      if (createSaving.value) return;
      const measurementsOne = parseMeasurementData(newMeasurementOneRaw.value);
      const measurementsTwo = parseMeasurementData(newMeasurementTwoRaw.value);
      const hasPhotos = createPhotoSlots.some(slot => !!slot.fileRef.value);
      const hasText = newCheckText.value.trim().length > 0;
      if (!hasPhotos && !measurementsOne.length && !measurementsTwo.length && !hasText) {
        alert('Inserisci almeno una foto, una misura o un testo prima di salvare.');
        return;
      }
      createSaving.value = true;
      try {
        const uploadedUrls = {};
        for (const slot of createPhotoSlots) {
          uploadedUrls[slot.field] = await uploadPhotoFile(slot.fileRef.value);
        }
        const imageOneUrl = uploadedUrls.imageOneUrl || '';
        const imageTwoUrl = uploadedUrls.imageTwoUrl || '';
        const imageThreeUrl = '';
        const imageFourUrl = '';
        const timestamp = serverTimestamp();
        const creationMode = newCheckType.value === 'baseline' ? 'manual_baseline' : 'manual';
        const isBaselineEntry = newCheckType.value === 'baseline';
        await addDoc(collection(db, 'check'), {
          userId: props.userId,
          text: newCheckText.value.trim(),
          measurementsOne,
          measurementsTwo,
          imageOneUrl,
          imageTwoUrl,
          imageThreeUrl,
          imageFourUrl,
          photoComparisons: [],
          visibilityProfile: newVisibilityProfile.value,
          approved: false,
          approvedAt: null,
          creationMode,
          isBaseline: isBaselineEntry,
          linkedQuestionnaireId: null,
          initialQuestionnaireId: null,
          percorsoId: newPercorsoId.value || null,
          stepIndex: null,
          createdAt: timestamp,
          updatedAt: timestamp
        });
        resetCreateForm();
        showCreate.value = false;
        alert('Check salvato con successo!');
      } catch (error) {
        console.error('Errore nel salvataggio del check manuale:', error);
        alert('Errore durante il salvataggio del check.');
      } finally {
        createSaving.value = false;
      }
    };

    const toggleCreate = () => {
      showCreate.value = !showCreate.value;
      if (!showCreate.value) {
        resetCreateForm();
      }
    };

    const setPhotoUploading = (checkId, slotKey, value) => {
      photoUploadFlags[`${checkId}_${slotKey}`] = value;
    };

    const isPhotoUploading = (checkId, slotKey) =>
      !!photoUploadFlags[`${checkId}_${slotKey}`];

    const hasInitialQuestionnaire = (check) =>
      !!(check && check.initialQuestionnaireId);

    const supportsInitialDataEdits = (check) =>
      !!check && !hasInitialQuestionnaire(check);

    const targetCheckDocId = (check) => {
      if (!check) return null;
      const id = String(check.id || '');
      if (id.startsWith('questionario_')) {
        return check.linkedQuestionnaireId || null;
      }
      return check.id || null;
    };

    const uploadExistingPhoto = async (check, slotKey, file) => {
      if (!check || !check.id) return;
      const slot = photoSlotByKey[slotKey];
      if (!slot || !file) return;
      setPhotoUploading(check.id, slot.key, true);
      try {
        const newUrl = await uploadPhotoFile(file);
        if (!newUrl) {
          alert('Caricamento foto non riuscito.');
          return;
        }
        await updateDoc(doc(db, 'check', check.id), {
          [slot.field]: newUrl,
          updatedAt: serverTimestamp()
        });
        const local = checks.value.find(c => c.id === check.id);
        if (local) {
          local[slot.field] = newUrl;
          local.updatedAt = new Date();
        }
      } catch (error) {
        console.error('Errore aggiornando la foto del check:', error);
        alert('Errore durante il caricamento della foto.');
      } finally {
        setPhotoUploading(check.id, slot.key, false);
      }
    };

    const handleExistingPhotoUpload = async (check, slotKey, event) => {
      const file = event?.target?.files?.[0];
      if (!file) return;
      await uploadExistingPhoto(check, slotKey, file);
      if (event?.target) event.target.value = '';
    };

    const onExistingPhotoDragEnter = (checkId, slotKey) => {
      setDropZoneHover(existingDropZoneKey(checkId, slotKey), true);
    };

    const onExistingPhotoDragLeave = (checkId, slotKey) => {
      setDropZoneHover(existingDropZoneKey(checkId, slotKey), false);
    };

    const onExistingPhotoDragOver = (event) => {
      event.preventDefault();
    };

    const onExistingPhotoDrop = async (check, slotKey, event) => {
      event.preventDefault();
      const key = existingDropZoneKey(check.id, slotKey);
      setDropZoneHover(key, false);
      const file = event?.dataTransfer?.files?.[0];
      if (!file) return;
      await uploadExistingPhoto(check, slotKey, file);
    };

    const isCheckApprovalSaving = (checkId) => !!approvalSaving[checkId];

    const setCheckApproval = async (check, approved) => {
      if (!check || !check.id) return;
      if (check.approved === approved) return;
      approvalSaving[check.id] = true;
      try {
        await updateDoc(doc(db, 'check', check.id), {
          approved,
          approvedAt: approved ? serverTimestamp() : null,
          updatedAt: serverTimestamp()
        });
        const nextDate = approved ? new Date() : null;
        check.approved = approved;
        check.approvedAt = nextDate;
        const local = checks.value.find(c => c.id === check.id);
        if (local) {
          local.approved = approved;
          local.approvedAt = nextDate;
          local.updatedAt = new Date();
        }
      } catch (error) {
        console.error('Errore aggiornando approvazione del check:', error);
        alert('Errore durante il salvataggio dello stato di approvazione.');
      } finally {
        approvalSaving[check.id] = false;
      }
    };

    const toggleCheckApproval = async (check) => {
      if (!check) return;
      await setCheckApproval(check, !check.approved);
    };

    const measurementRowsToText = (rows = []) => {
      if (!Array.isArray(rows) || !rows.length) return '';
      return rows
        .map(row => `${row?.caratteristica || ''}  ${row?.valore || ''}  ${row?.data || ''}`)
        .join('\n');
    };

    const openMeasurementEditor = (check) => {
      if (!check || !check.id) return;
      measurementEditors[check.id] = {
        visible: true,
        m1: measurementRowsToText(check.measurementsOne),
        m2: measurementRowsToText(check.measurementsTwo),
        saving: false
      };
    };

    const closeMeasurementEditor = (checkId) => {
      if (measurementEditors[checkId]) {
        delete measurementEditors[checkId];
      }
    };

    const saveMeasurementEditor = async (check) => {
      if (!check || !check.id) return;
      const editor = measurementEditors[check.id];
      if (!editor) return;
      editor.saving = true;
      try {
        const measurementsOne = parseMeasurementData(editor.m1);
        const measurementsTwo = parseMeasurementData(editor.m2);
        await updateDoc(doc(db, 'check', check.id), {
          measurementsOne,
          measurementsTwo,
          updatedAt: serverTimestamp()
        });
        const local = checks.value.find(c => c.id === check.id);
        if (local) {
          local.measurementsOne = measurementsOne;
          local.measurementsTwo = measurementsTwo;
          local.updatedAt = new Date();
        }
        delete measurementEditors[check.id];
      } catch (error) {
        console.error('Errore aggiornando le misure del check:', error);
        alert('Errore durante il salvataggio delle misure.');
      } finally {
        editor.saving = false;
      }
    };

    const openInitialMeasurementEditor = (check) => {
      if (!check || !check.id) return;
      if (!supportsInitialDataEdits(check)) {
        alert('Le misure iniziali provengono dal questionario e non sono modificabili qui.');
        return;
      }
      const targetId = targetCheckDocId(check);
      if (!targetId) {
        alert('Impossibile individuare il check di destinazione per le misure.');
        return;
      }
      initialMeasurementEditors[check.id] = {
        targetDocId: targetId,
        text: measurementRowsToText(check.measurementsOne),
        saving: false
      };
    };

    const closeInitialMeasurementEditor = (checkId) => {
      if (initialMeasurementEditors[checkId]) {
        delete initialMeasurementEditors[checkId];
      }
    };

    const saveInitialMeasurementEditor = async (check) => {
      if (!check || !check.id) return;
      const editor = initialMeasurementEditors[check.id];
      if (!editor) return;
      editor.saving = true;
      try {
        const rows = parseMeasurementData(editor.text);
        if (!rows.length) {
          alert('Inserisci almeno una misura per salvarla.');
          editor.saving = false;
          return;
        }
        const targetId = editor.targetDocId || targetCheckDocId(check);
        if (!targetId) {
          alert('Impossibile salvare le misure: check di destinazione non trovato.');
          editor.saving = false;
          return;
        }

        const payload = {
          measurementsOne: rows,
          updatedAt: serverTimestamp()
        };
        if (check.linkedQuestionnaireId) payload.linkedQuestionnaireId = check.linkedQuestionnaireId;
        if (check.creationMode) payload.creationMode = check.creationMode;
        payload.userId = props.userId;

        const existingDoc = checks.value.find(c => c.id === targetId);
        if (!existingDoc) {
          payload.createdAt = serverTimestamp();
        }

        await setDoc(doc(db, 'check', targetId), payload, { merge: true });

        if (existingDoc) {
          existingDoc.measurementsOne = rows;
          existingDoc.updatedAt = new Date();
        }
        check.measurementsOne = rows;
        check.updatedAt = new Date();

        delete initialMeasurementEditors[check.id];
        await rebuildQuestionnaireComparisons();
      } catch (error) {
        console.error('Errore aggiornando le misure iniziali del questionario:', error);
        alert('Errore durante il salvataggio delle misure iniziali.');
      } finally {
        editor.saving = false;
      }
    };

    const manualBaselinesByPercorso = computed(() => {
      const map = new Map();
      checks.value.forEach(check => {
        if (!check?.percorsoId) return;
        const isBaseline = check.isBaseline || check.creationMode === 'manual_baseline';
        if (!isBaseline) return;
        const hasMeasurements = Array.isArray(check.measurementsOne) && check.measurementsOne.length;
        const hasPhotos = !!(check.imageOneUrl || check.imageTwoUrl || check.imageThreeUrl || check.imageFourUrl);
        const hasPhotoComparisons = Array.isArray(check.photoComparisons) && check.photoComparisons.length;
        if (!hasMeasurements && !hasPhotos && !hasPhotoComparisons) return;
        const createdTs = toDate(check.createdAt)?.getTime() ?? 0;
        const updatedTs = toDate(check.updatedAt)?.getTime() ?? createdTs;
        const existing = map.get(check.percorsoId);
        const existingCreated = existing ? existing.timestamp : -Infinity;
        const existingUpdated = existing ? (existing.updatedTimestamp ?? existingCreated) : -Infinity;
        const shouldReplace =
          !existing ||
          createdTs > existingCreated ||
          (createdTs === existingCreated && updatedTs >= existingUpdated);
        if (shouldReplace) {
          map.set(check.percorsoId, { ...check, timestamp: createdTs, updatedTimestamp: updatedTs });
        }
      });
      return map;
    });

    // Individua il primo step convertito (questionario -> check) per ciascun percorso
    const convertedStepsByPercorso = computed(() => {
      const map = new Map();
      percorsi.value.forEach(percorso => {
        if (!percorso?.id) return;
        const steps = Array.isArray(percorso.steps) ? percorso.steps : [];
        const idx = steps.findIndex(step => step?.convertedFromQuestionario);
        if (idx < 0) return;
        map.set(percorso.id, { stepIndex: idx, step: steps[idx], percorso });
      });
      return map;
    });

    const isConvertedBaselineDoc = (doc) => {
      if (!doc) return false;
      const percorsoId = doc.percorsoId || null;
      if (!percorsoId) return false;
      const meta = convertedStepsByPercorso.value.get(percorsoId);
      if (!meta) return false;
      const docIndex = toOptionalNumber(doc.stepIndex);
      if (Number.isInteger(meta.stepIndex) && docIndex != null && meta.stepIndex !== docIndex) {
        return false;
      }
      const key = (doc.stepKey || '').toLowerCase();
      return key === 'check_finale';
    };

    async function ensureUrls(metaList = []) {
      const urls = [];
      for (const meta of metaList) {
        if (!meta) continue;

        if (typeof meta === 'string') {
          const trimmed = meta.trim();
          if (!trimmed) continue;
          if (/^https?:\/\//i.test(trimmed)) {
            urls.push(trimmed);
            continue;
          }
          if (!fileUrlCache.has(trimmed)) {
            try {
              const url = await getDownloadURL(storageRef(storage, trimmed));
              fileUrlCache.set(trimmed, url);
            } catch (err) {
              console.error('ensureUrls error', err);
              fileUrlCache.set(trimmed, null);
            }
          }
          const resolvedDirect = fileUrlCache.get(trimmed);
          if (resolvedDirect) urls.push(resolvedDirect);
          continue;
        }

        const directUrl =
          meta.url ||
          meta.downloadUrl ||
          meta.downloadURL ||
          meta._url;
        if (directUrl) {
          urls.push(directUrl);
          continue;
        }

        const path = meta.path || meta.storagePath || meta.referencePath;
        if (path) {
          if (!fileUrlCache.has(path)) {
            try {
              const url = await getDownloadURL(storageRef(storage, path));
              fileUrlCache.set(path, url);
            } catch (err) {
              console.error('ensureUrls error', err);
              fileUrlCache.set(path, null);
            }
          }
          const resolved = fileUrlCache.get(path);
          if (resolved) urls.push(resolved);
          continue;
        }

        if (Array.isArray(meta.files) && meta.files.length) {
          const nested = await ensureUrls(meta.files);
          urls.push(...nested);
        }
      }
      return Array.from(new Set(urls.filter(Boolean)));
    }

    const buildMeasurements = (answers, defs, dateLabel) => {
      if (!answers) return [];
      return defs
        .map(def => {
          const keys = [def.key, ...(def.aliases || [])];
          let raw = null;
          for (const key of keys) {
            raw = valueFromAnswer(answers, key);
            if (raw !== null && raw !== undefined && raw !== '') break;
          }
          const formatted = formatMeasurementValue(raw);
          if (!formatted) return null;
          return {
            caratteristica: def.label,
            valore: formatted,
            data: dateLabel || ''
          };
        })
        .filter(Boolean);
    };

    const buildPhotoComparisons = async ({ answers, initialAnswers, extraInitialAnswers = [], baselinePhotos }) => {
      const out = [];
      for (const field of PHOTO_FIELD_MAP) {
        const answerKeys = field.answerKeys || (field.key ? [field.key] : []);
        const initialKeys = Array.from(new Set([...(field.initialKeys || []), ...answerKeys]));
        const initialPaths = Array.from(
          new Map(
            [...(field.initialPaths || []), ...(field.answerPaths || [])]
              .map(path => [Array.isArray(path) ? path.join('.') : String(path), path])
          ).values()
        );
        const checkMetas = collectPhotoMetas(answers, answerKeys, field.answerPaths || []);
        const initialMetas = [
          ...collectPhotoMetas(initialAnswers, initialKeys, initialPaths),
          ...extraInitialAnswers.flatMap(source => collectPhotoMetas(source, initialKeys, initialPaths))
        ];

        let checkUrls = await ensureUrls(checkMetas);
        let initialUrls = await ensureUrls(initialMetas);

        if (baselinePhotos && baselinePhotos[field.key]?.length) {
          initialUrls = Array.from(new Set([...initialUrls, ...baselinePhotos[field.key]]));
        }

        if (!initialUrls.length && !checkUrls.length) continue;

        out.push({
          key: field.key,
          label: field.label,
          initialUrls,
          checkUrls,
          isPrimary: !!field.isPrimary
        });
      }
      return out;
    };

    const extractManualBaselinePhotos = (baseline) => {
      if (!baseline) return {};
      const photos = {};
      const push = (key, url) => {
        if (!url) return;
        if (!photos[key]) photos[key] = [];
        if (!photos[key].includes(url)) photos[key].push(url);
      };
      push('foto_frontale', baseline.imageOneUrl);
      push('foto_posteriore', baseline.imageTwoUrl);
      push('foto_lato_sinistro', baseline.imageThreeUrl);
      push('foto_lato_destro', baseline.imageFourUrl);
      if (Array.isArray(baseline.photoComparisons)) {
        baseline.photoComparisons.forEach(entry => {
          const key = entry?.key || entry?.label;
          if (!key) return;
          const normalizedKey = key.startsWith('foto_') ? key : `foto_${key}`;
          (Array.isArray(entry.initialUrls) ? entry.initialUrls : []).forEach(url => push(normalizedKey, url));
        });
      }
      return photos;
    };

    const buildComparisonFromQuestion = async (docData, initialDoc, manualBaseline, extraInitialAnswers = []) => {
      if (!docData) return null;
      const answers = docData.answers || {};
      const percorsoId = docData.percorsoId || initialDoc?.percorsoId || null;
      const stepIndexValue = toOptionalNumber(docData.stepIndex);
      const createdAt = toDate(docData.createdAt);

      const docMeta = {
        percorsoId,
        stepIndex: stepIndexValue,
        stepKey: docData.stepKey || 'check_finale',
        sequenceGroupId: docData.sequenceGroupId || null,
        sequenceIndex: toOptionalNumber(docData.sequenceIndex),
        sequenceTotal: toOptionalNumber(docData.sequenceTotal),
        productId: docData.productId || null,
        productName: docData.productName || null,
        programTitle: docData.programTitle || docData.programLabel || null,
        programLabel: docData.programLabel || docData.programTitle || null,
        plannedStartAt: docData.plannedStartAt || null,
        expireAt: docData.expireAt || null,
        stepName: docData.stepName || null
      };

      const snapshotInitialAnswers = docData.initialAnswersSnapshot || null;
      const initialAnswers = initialDoc?.answers || snapshotInitialAnswers;
      const snapshotInfo = docData.initialQuestionarioInfoSnapshot || {};
      const initialDateSource = initialDoc?.createdAt || snapshotInfo.createdAt || null;
      const initialDateLabel = initialDateSource ? formatDate(initialDateSource) : '';
      const checkDateLabel = createdAt ? formatDate(createdAt) : '';
      const baselinePhotos = manualBaseline ? extractManualBaselinePhotos(manualBaseline) : {};
      const allExtraInitialAnswers = [
        snapshotInitialAnswers && snapshotInitialAnswers !== initialAnswers ? snapshotInitialAnswers : null,
        ...extraInitialAnswers
      ].filter(Boolean);

      let measurementsOne = buildMeasurements(initialAnswers, INITIAL_MEASUREMENT_FIELDS, initialDateLabel);
      if ((!measurementsOne || !measurementsOne.length) && Array.isArray(manualBaseline?.measurementsOne) && manualBaseline.measurementsOne.length) {
        measurementsOne = manualBaseline.measurementsOne.map(row => ({ ...row }));
      }
      const measurementsTwo = buildMeasurements(answers, CHECK_MEASUREMENT_FIELDS, checkDateLabel);

      const photoComparisons = await buildPhotoComparisons({
        answers,
        initialAnswers,
        extraInitialAnswers: allExtraInitialAnswers,
        baselinePhotos
      });
      const primaryPhotoComparisons = photoComparisons.filter(entry => entry.isPrimary);
      const combinedPhotos = primaryPhotoComparisons.length ? primaryPhotoComparisons : photoComparisons;

      if (!combinedPhotos.length && !measurementsOne.length && !measurementsTwo.length) {
        return null;
      }

      const baselineCheckId =
        manualBaseline?.id ||
        (initialDoc?.source === 'converted_check' ? initialDoc.id : null);
      const baselineSource = manualBaseline
        ? 'manual_check'
        : initialDoc
        ? initialDoc.source || 'questionnaire'
        : null;

      const initialMeta = initialDoc
        ? {
            id: initialDoc.id,
            percorsoId: initialDoc.percorsoId || docMeta.percorsoId || null,
            stepIndex: toOptionalNumber(initialDoc.stepIndex),
            stepKey: initialDoc.stepKey || 'questionario',
            sequenceGroupId: initialDoc.sequenceGroupId || docMeta.sequenceGroupId || null,
            sequenceIndex: toOptionalNumber(initialDoc.sequenceIndex),
            sequenceTotal: toOptionalNumber(initialDoc.sequenceTotal),
            productId: initialDoc.productId || docMeta.productId || null,
            productName: initialDoc.productName || docMeta.productName || null,
            programTitle: initialDoc.programTitle || docMeta.programTitle || null,
            programLabel: initialDoc.programLabel || docMeta.programLabel || null,
            plannedStartAt: initialDoc.plannedStartAt || docMeta.plannedStartAt || null,
            expireAt: initialDoc.expireAt || docMeta.expireAt || null,
            stepName: initialDoc.stepName || null
          }
        : null;

      return {
        id: `questionario_${docData.id}`,
        creationMode: 'automatic',
        linkedQuestionnaireId: docData.id,
        initialQuestionnaireId: initialDoc?.id || null,
        baselineCheckId,
        baselineSource,
        percorsoId,
        stepIndex: stepIndexValue,
        stepKey: docMeta.stepKey,
        createdAt,
        measurementsOne,
        measurementsTwo,
        photoComparisons: combinedPhotos,
        meta: docMeta,
        initialMeta
      };
    };

    const mapCheckDoc = (docSnap) => {
      const data = docSnap.data() || {};
      return {
        id: docSnap.id,
        creationMode: data.creationMode || (data.linkedQuestionnaireId ? 'automatic' : 'manual'),
        linkedQuestionnaireId: data.linkedQuestionnaireId || null,
        initialQuestionnaireId: data.initialQuestionnaireId || null,
        percorsoId: data.percorsoId || null,
        stepIndex: toOptionalNumber(data.stepIndex),
        stepKey: data.stepKey || null,
        text: data.text || '',
        measurementsOne: Array.isArray(data.measurementsOne) ? data.measurementsOne : [],
        measurementsTwo: Array.isArray(data.measurementsTwo) ? data.measurementsTwo : [],
        imageOneUrl: data.imageOneUrl || '',
        imageTwoUrl: data.imageTwoUrl || '',
        imageThreeUrl: data.imageThreeUrl || '',
        imageFourUrl: data.imageFourUrl || '',
        photoComparisons: Array.isArray(data.photoComparisons) ? data.photoComparisons : [],
        visibilityProfile: data.visibilityProfile ?? true,
        approved: data.approved === true,
        approvedAt: toDate(data.approvedAt),
        gender: data.gender || '',
        ageGroup: data.ageGroup || '',
        menopausa: data.menopausa || '',
        haSeguito: data.haSeguito || '',
        tipoPercorso: data.tipoPercorso || '',
        haAvutoProgressi: data.haAvutoProgressi || '',
        respectAllenamento: data.respectAllenamento || '',
        respectNutrizione: data.respectNutrizione || '',
        acquaAssunta: data.acquaAssunta || '',
        riposoCorretta: data.riposoCorretta || '',
        isBaseline: data.isBaseline || data.creationMode === 'manual_baseline',
        autoGeneratedBaseline: data.autoGeneratedBaseline === true,
        createdAt: toDate(data.createdAt),
        updatedAt: toDate(data.updatedAt),
        sequenceGroupId: data.sequenceGroupId || null,
        sequenceIndex: toOptionalNumber(data.sequenceIndex),
        sequenceTotal: toOptionalNumber(data.sequenceTotal),
        productId: data.productId || null,
        productName: data.productName || null,
        programTitle: data.programTitle || data.programLabel || null,
        programLabel: data.programLabel || data.programTitle || null,
        plannedStartAt: data.plannedStartAt || null,
        expireAt: data.expireAt || null,
        stepName: data.stepName || null,
        meta: {
          percorsoId: data.percorsoId || null,
          stepIndex: toOptionalNumber(data.stepIndex),
          stepKey: data.stepKey || null,
          sequenceGroupId: data.sequenceGroupId || null,
          sequenceIndex: toOptionalNumber(data.sequenceIndex),
          sequenceTotal: toOptionalNumber(data.sequenceTotal),
          productId: data.productId || null,
          productName: data.productName || null,
          programTitle: data.programTitle || data.programLabel || null,
          programLabel: data.programLabel || data.programTitle || null,
          plannedStartAt: data.plannedStartAt || null,
          expireAt: data.expireAt || null,
          stepName: data.stepName || null
        },
        initialMeta: null
      };
    };

    const subscribeChecks = (uid) => {
      if (unsubscribeChecks) {
        unsubscribeChecks();
        unsubscribeChecks = null;
      }
      checks.value = [];
      checksError.value = '';
      if (!uid) return;

      checksLoading.value = true;
      try {
        const baseQuery = query(
          collection(db, 'check'),
          where('userId', '==', uid),
          orderBy('createdAt', 'desc')
        );
        unsubscribeChecks = onSnapshot(
          baseQuery,
          (snap) => {
            checks.value = snap.docs.map(mapCheckDoc);
            checksLoading.value = false;
            checksError.value = '';
          },
          (err) => {
            console.error('Errore caricamento check:', err);
            checks.value = [];
            checksLoading.value = false;
            checksError.value = err.message || String(err);
          }
        );
      } catch (err) {
        console.error('Errore creazione query check:', err);
        checks.value = [];
        checksLoading.value = false;
        checksError.value = err.message || String(err);
      }
    };

    const subscribeDafareChecks = (uid) => {
      if (unsubscribeDafare) {
        unsubscribeDafare();
        unsubscribeDafare = null;
      }
      dafareChecks.value = [];
      if (!uid) return;

      try {
        const qRef = query(
          collection(db, 'checkdafare'),
          where('uid', '==', uid),
          orderBy('createdAt', 'desc')
        );
        unsubscribeDafare = onSnapshot(qRef, (snap) => {
          dafareChecks.value = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        });
      } catch (err) {
        console.error('Errore caricamento checkdafare:', err);
      }
    };

    const rebuildQuestionnaireComparisons = async () => {
      const rows = questionnaireDocs.value || [];
      if (!rows.length) {
        questionnaireComparisons.value = [];
        questionnaireLoading.value = false;
        return;
      }
      questionnaireLoading.value = true;
      try {
        const grouped = new Map();
        rows.forEach((row) => {
          const key = questionnaireGroupKey(row);
          if (!grouped.has(key)) grouped.set(key, []);
          grouped.get(key).push(row);
        });

        const comparisons = [];

        const toInitialDoc = (source, sourceType = 'questionnaire') => ({
          id: source.id,
          answers: source.answers || {},
          createdAt: toDate(source.createdAt),
          percorsoId: source.percorsoId || null,
          stepIndex: toOptionalNumber(source.stepIndex),
          stepKey: sourceType === 'converted_check' ? 'questionario' : source.stepKey || 'questionario',
          sequenceGroupId: source.sequenceGroupId || null,
          sequenceIndex: toOptionalNumber(source.sequenceIndex),
          sequenceTotal: toOptionalNumber(source.sequenceTotal),
          productId: source.productId || null,
          productName: source.productName || null,
          programTitle: source.programTitle || source.programLabel || null,
          programLabel: source.programLabel || source.programTitle || null,
          plannedStartAt: source.plannedStartAt || null,
          expireAt: source.expireAt || null,
          stepName: source.stepName || null,
          raw: source,
          source: sourceType
        });

        for (const list of grouped.values()) {
          const initialCandidates = list
            .filter(item => (item.stepKey || '').toLowerCase() === 'questionario')
            .sort((a, b) => {
              const ta = toDate(a.createdAt)?.getTime() ?? Number.POSITIVE_INFINITY;
              const tb = toDate(b.createdAt)?.getTime() ?? Number.POSITIVE_INFINITY;
              return ta - tb;
            });

          const convertedCandidates = list
            .filter(item => isConvertedBaselineDoc(item))
            .sort((a, b) => {
              const ta = toDate(a.createdAt)?.getTime() ?? Number.POSITIVE_INFINITY;
              const tb = toDate(b.createdAt)?.getTime() ?? Number.POSITIVE_INFINITY;
              return ta - tb;
            });

          const initialSource =
            initialCandidates.find((candidate) => hasBaselineData(candidate)) ||
            convertedCandidates.find((candidate) => hasBaselineData(candidate)) ||
            initialCandidates[0] ||
            convertedCandidates[0] ||
            null;
          const initialDoc = initialSource
            ? toInitialDoc(
                initialSource,
                isConvertedBaselineDoc(initialSource) ? 'converted_check' : 'questionnaire'
              )
            : null;
          const extraInitialAnswers = [initialCandidates[0], convertedCandidates[0]]
            .filter(source => source && source.id !== initialDoc?.id)
            .map(source => source.answers || {});

          const baselineDocId = initialDoc?.id || null;
          const checkRows = list
            .filter(item => (item.stepKey || '').toLowerCase() === 'check_finale')
            .filter(item => item.id !== baselineDocId);

          for (const row of checkRows) {
            const percorsoId = row.percorsoId || initialDoc?.percorsoId || null;
            const manualBaseline = percorsoId ? manualBaselinesByPercorso.value.get(percorsoId) : null;
            const comp = await buildComparisonFromQuestion(row, initialDoc, manualBaseline, extraInitialAnswers);
            if (comp) comparisons.push(comp);
          }
        }

        questionnaireComparisons.value = comparisons;
        questionnaireError.value = '';
      } catch (errInner) {
        console.error('Errore costruzione comparazioni questionari:', errInner);
        questionnaireComparisons.value = [];
        questionnaireError.value = errInner.message || String(errInner);
      } finally {
        questionnaireLoading.value = false;
      }
    };

    const subscribeQuestionari = (uid) => {
      if (unsubscribeQuestionari) {
        unsubscribeQuestionari();
        unsubscribeQuestionari = null;
      }
      questionnaireComparisons.value = [];
      questionnaireError.value = '';
      if (!uid) {
        questionnaireLoading.value = false;
        questionnaireDocs.value = [];
        questionnaireComparisons.value = [];
        return;
      }

      questionnaireDocs.value = [];

      try {
        const qRef = query(collection(db, 'questionari'), where('uid', '==', uid));
        questionnaireLoading.value = true;
        unsubscribeQuestionari = onSnapshot(
          qRef,
          async (snap) => {
            const rawRows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            questionnaireDocs.value = rawRows;
            await rebuildQuestionnaireComparisons();
          },
          (err) => {
            console.error('Errore caricamento questionari:', err);
            questionnaireComparisons.value = [];
            questionnaireLoading.value = false;
            questionnaireError.value = err.message || String(err);
          }
        );
      } catch (err) {
        console.error('Errore creazione query questionari:', err);
        questionnaireComparisons.value = [];
        questionnaireLoading.value = false;
        questionnaireError.value = err.message || String(err);
      }
    };

    const updateDafareCheckField = async (id, field, value) => {
      try {
        const refDoc = doc(db, 'checkdafare', id);
        await updateDoc(refDoc, { [field]: value });
      } catch (error) {
        console.error('Errore aggiornamento checkdafare:', error);
      }
    };

    const formatDate = (dateInput) => formatDateBasic(dateInput);

    const compareByDateDesc = (a, b) => {
      const aCreated = toDate(a?.createdAt)?.getTime() ?? -Infinity;
      const bCreated = toDate(b?.createdAt)?.getTime() ?? -Infinity;
      if (aCreated !== bCreated) return bCreated - aCreated;

      const aUpdated = toDate(a?.updatedAt)?.getTime() ?? -Infinity;
      const bUpdated = toDate(b?.updatedAt)?.getTime() ?? -Infinity;
      if (aUpdated !== bUpdated) return bUpdated - aUpdated;

      const aId = String(a?.id || '');
      const bId = String(b?.id || '');
      return bId.localeCompare(aId);
    };

    const formatDateTime = (dateInput) => {
      const d = toDate(dateInput);
      if (!d) return '';
      const datePart = d.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      const timePart = d.toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit'
      });
      return `${datePart} ${timePart}`;
    };

    const photoComparisonsFor = (check) => {
      if (Array.isArray(check.photoComparisons) && check.photoComparisons.length) {
        return check.photoComparisons.map(entry => ({
          key: entry.key || entry.label || '',
          label: entry.label || 'Foto',
          initialUrls: Array.isArray(entry.initialUrls) ? entry.initialUrls : [],
          checkUrls: Array.isArray(entry.checkUrls) ? entry.checkUrls : []
        }));
      }

      const legacyPairs = [
        { key: 'manual_pair_1', label: 'Confronto Foto 1-2', initialUrl: check.imageOneUrl, checkUrl: check.imageTwoUrl },
        { key: 'manual_pair_2', label: 'Confronto Foto 3-4', initialUrl: check.imageThreeUrl, checkUrl: check.imageFourUrl }
      ]
        .map(pair => ({
          key: pair.key,
          label: pair.label,
          initialUrls: pair.initialUrl ? [pair.initialUrl] : [],
          checkUrls: pair.checkUrl ? [pair.checkUrl] : []
        }))
        .filter(entry => entry.initialUrls.length || entry.checkUrls.length);

      return legacyPairs;
    };

    const hasPhotoComparison = (check) => photoComparisonsFor(check).some(entry => entry.initialUrls.length || entry.checkUrls.length);
    const measurementComparisonsFor = (check) => {
      const map = new Map();
      const addRow = (row, type) => {
        if (!row || !row.caratteristica) return;
        const key = row.caratteristica;
        const entry = map.get(key) || {
          label: key,
          initialValue: '',
          checkValue: '',
          initialDate: '',
          checkDate: ''
        };
        if (type === 'initial') {
          entry.initialValue = row.valore ?? '';
          entry.initialDate = row.data ?? '';
        } else if (type === 'check') {
          entry.checkValue = row.valore ?? '';
          entry.checkDate = row.data ?? '';
        }
        map.set(key, entry);
      };

      (Array.isArray(check.measurementsOne) ? check.measurementsOne : []).forEach(row => addRow(row, 'initial'));
      (Array.isArray(check.measurementsTwo) ? check.measurementsTwo : []).forEach(row => addRow(row, 'check'));
      return Array.from(map.values());
    };

    const hasMeasurements = (check) => measurementComparisonsFor(check).length > 0;

    const hasInitialMeasurements = (check) =>
      measurementComparisonsFor(check).some(row => {
        if (row.initialValue === null || row.initialValue === undefined) return false;
        if (typeof row.initialValue === 'string') return row.initialValue.trim().length > 0;
        return true;
      });

    const manualHistoryChecks = computed(() => {
      const list = checks.value.filter((check) =>
        check.creationMode === 'manual' ||
        (check.creationMode === 'manual_baseline' && !check.autoGeneratedBaseline)
      );
      return list.sort(compareByDateDesc);
    });

    const automaticChecks = computed(() =>
      checks.value.filter(check => {
        const inferredAuto =
          check.creationMode === 'automatic' ||
          (!!check.linkedQuestionnaireId && check.creationMode !== 'manual');
        return inferredAuto;
      })
    );

    const comparisonChecks = computed(() => {
      const map = new Map();

      automaticChecks.value.forEach(check => {
        const key = check.linkedQuestionnaireId || check.id;
        map.set(key, check);
      });

      questionnaireComparisons.value.forEach(comp => {
        const key = comp.linkedQuestionnaireId || comp.id;
        const existing = map.get(key);
        if (!existing) {
          map.set(key, comp);
          return;
        }

        map.set(key, {
          ...existing,
          ...comp,
          id: existing.id || comp.id,
          creationMode: existing.creationMode || comp.creationMode,
          linkedQuestionnaireId: existing.linkedQuestionnaireId || comp.linkedQuestionnaireId,
          photoComparisons: Array.isArray(comp.photoComparisons) && comp.photoComparisons.length
            ? comp.photoComparisons
            : existing.photoComparisons,
          measurementsOne: Array.isArray(comp.measurementsOne) && comp.measurementsOne.length
            ? comp.measurementsOne
            : existing.measurementsOne,
          measurementsTwo: Array.isArray(comp.measurementsTwo) && comp.measurementsTwo.length
            ? comp.measurementsTwo
            : existing.measurementsTwo,
          meta: { ...(existing.meta || {}), ...(comp.meta || {}) },
          initialMeta: comp.initialMeta || existing.initialMeta || null
        });
      });

      const list = Array.from(map.values()).filter(entry => hasPhotoComparison(entry) || hasMeasurements(entry));
      return list.sort(compareByDateDesc);
    });

    const findInitialQuestionnaireMeta = (check) => {
      if (!check) return null;
      if (check.initialMeta) return check.initialMeta;
      if (!check.percorsoId) return null;
      const docs = (questionnaireDocs.value || []).filter(
        (doc) =>
          (doc.percorsoId || null) === check.percorsoId &&
          (doc.stepKey || '').toLowerCase() === 'questionario'
      );
      if (!docs.length) return null;
      docs.sort((a, b) => {
        const ta = toDate(a.createdAt)?.getTime() ?? Number.POSITIVE_INFINITY;
        const tb = toDate(b.createdAt)?.getTime() ?? Number.POSITIVE_INFINITY;
        return ta - tb;
      });
      const doc = docs[0];
  if (!doc) return null;
  return {
    id: doc.id,
    percorsoId: doc.percorsoId || null,
    stepIndex: toOptionalNumber(doc.stepIndex),
        stepKey: doc.stepKey || 'questionario',
        sequenceGroupId: doc.sequenceGroupId || null,
        sequenceIndex: toOptionalNumber(doc.sequenceIndex),
        sequenceTotal: toOptionalNumber(doc.sequenceTotal),
        productId: doc.productId || null,
        productName: doc.productName || null,
        programTitle: doc.programTitle || doc.programLabel || null,
        programLabel: doc.programLabel || doc.programTitle || null,
    plannedStartAt: doc.plannedStartAt || null,
    expireAt: doc.expireAt || null,
    stepName: doc.stepName || null
  };
};

const findPercorsoById = (percorsoId) => {
  if (!percorsoId) return null;
  return percorsi.value.find(p => p.id === percorsoId) || null;
};

const findQuestionnaireStepIndex = (percorso, hintIndex = null) => {
  if (Number.isInteger(hintIndex) && hintIndex >= 0) return hintIndex;
  const steps = Array.isArray(percorso?.steps) ? percorso.steps : [];
  if (!steps.length) return null;
  const idx = steps.findIndex(step => {
    const name = String(step?.name || '').toLowerCase();
    const key = String(step?.stepKey || step?.key || '').toLowerCase();
    return name.includes('questionario') || key.includes('questionario');
  });
  return idx >= 0 ? idx : null;
};

const buildPercorsoMeta = (percorso, stepIndex) => {
  if (!percorso) return {};
  const meta = {
    percorsoId: percorso.id || null,
    stepKey: 'questionario',
    stepIndex,
    sequenceGroupId: percorso.sequenceGroupId || percorso.id || null,
    sequenceIndex: toOptionalNumber(percorso.sequenceIndex),
    sequenceTotal: toOptionalNumber(percorso.sequenceTotal),
    productId: percorso.productId || null,
    productName: percorso.productName || null,
    programTitle: percorso.title || percorso.productName || null,
    programLabel: percorso.title || percorso.productName || null,
    plannedStartAt: percorso.plannedStartAt || null,
    expireAt: percorso.expireAt || null,
  };
  if (Number.isInteger(stepIndex) && Array.isArray(percorso.steps)) {
    meta.stepName = percorso.steps[stepIndex]?.name || 'Questionario iniziale';
  } else if (Array.isArray(percorso.steps) && percorso.steps.length) {
    meta.stepName = percorso.steps[0]?.name || 'Questionario iniziale';
  } else {
    meta.stepName = 'Questionario iniziale';
  }
  return meta;
};

    const buildQuestionnaireRouteQuery = (primaryMeta = {}, fallbackMeta = {}, percorsoMeta = {}) => {
      const sources = [primaryMeta || {}, fallbackMeta || {}, percorsoMeta || {}];
      const pick = (key) => {
        for (const src of sources) {
          const value = src?.[key];
          if (value === undefined || value === null) continue;
          if (typeof value === 'string' && value.trim() === '') continue;
          return value;
        }
        return null;
      };

      const query = {};
      const assign = (key, value) => {
        if (value === undefined || value === null) return;
        const str = typeof value === 'string' ? value : String(value);
        if (str.trim() === '') return;
        query[key] = str;
      };

      assign('percorsoId', pick('percorsoId'));
      assign('stepKey', pick('stepKey') || 'questionario');

      const stepIndexValue = toOptionalNumber(pick('stepIndex'));
      if (stepIndexValue !== null) assign('stepIndex', stepIndexValue);

      assign('sequenceGroupId', pick('sequenceGroupId'));
      assign('sequenceIndex', pick('sequenceIndex'));
      assign('sequenceTotal', pick('sequenceTotal'));
      assign('productId', pick('productId'));
      assign('productName', pick('productName'));
      assign('programTitle', pick('programTitle'));
      assign('programLabel', pick('programLabel'));
      assign('plannedStartAt', pick('plannedStartAt'));
      assign('expireAt', pick('expireAt'));
      assign('stepName', pick('stepName'));

      return query;
    };

    const openInitialQuestionnaire = (check) => {
      if (!props.userId) return;

      const primaryMeta = findInitialQuestionnaireMeta(check);
      const fallbackMeta = {
        percorsoId: check?.percorsoId ?? check?.meta?.percorsoId ?? null,
        stepKey: 'questionario',
        stepIndex: toOptionalNumber(check?.meta?.stepIndex ?? check?.stepIndex),
        sequenceGroupId: check?.sequenceGroupId ?? check?.meta?.sequenceGroupId ?? null,
        sequenceIndex: toOptionalNumber(check?.sequenceIndex ?? check?.meta?.sequenceIndex),
        sequenceTotal: toOptionalNumber(check?.sequenceTotal ?? check?.meta?.sequenceTotal),
        productId: check?.productId ?? check?.meta?.productId ?? null,
        productName: check?.productName ?? check?.meta?.productName ?? null,
        programTitle: check?.programTitle ?? check?.meta?.programTitle ?? null,
        programLabel: check?.programLabel ?? check?.meta?.programLabel ?? null,
        plannedStartAt: check?.plannedStartAt ?? check?.meta?.plannedStartAt ?? null,
        expireAt: check?.expireAt ?? check?.meta?.expireAt ?? null,
        stepName: check?.stepName ?? check?.meta?.stepName ?? null
      };

      const percorsoId =
        primaryMeta?.percorsoId ||
        fallbackMeta.percorsoId ||
        check?.percorsoId ||
        null;

      const percorso = findPercorsoById(percorsoId);
      if (!percorso) {
        alert('Impossibile aprire il questionario iniziale: percorso non disponibile.');
        return;
      }

      const resolvedStepIndex = findQuestionnaireStepIndex(
        percorso,
        toOptionalNumber(primaryMeta?.stepIndex ?? fallbackMeta.stepIndex)
      );
      if (!Number.isInteger(resolvedStepIndex)) {
        alert('Impossibile individuare lo step del questionario iniziale per questo programma.');
        return;
      }

      const normalizedPrimaryMeta = primaryMeta
        ? {
            ...primaryMeta,
            percorsoId,
            stepIndex: resolvedStepIndex,
            stepKey: primaryMeta.stepKey || 'questionario'
          }
        : {};

      const normalizedFallbackMeta = {
        ...fallbackMeta,
        percorsoId,
        stepIndex: resolvedStepIndex,
        stepKey: fallbackMeta.stepKey || 'questionario'
      };

      const percorsoMeta = buildPercorsoMeta(percorso, resolvedStepIndex);
      const query = buildQuestionnaireRouteQuery(normalizedPrimaryMeta, normalizedFallbackMeta, percorsoMeta);

      if (Number.isInteger(resolvedStepIndex)) {
        query.stepIndex = String(resolvedStepIndex);
      } else {
        delete query.stepIndex;
      }
      query.stepKey = 'questionario';
      if (percorsoMeta.stepName) {
        query.stepName = percorsoMeta.stepName;
      } else {
        query.stepName = 'Questionario iniziale';
      }

      const normalizeId = (value) => {
        if (value === undefined || value === null) return '';
        const str = typeof value === 'string' ? value : String(value);
        return str.trim();
      };

      const isQuestionarioStep = (meta) => {
        if (!meta) return false;
        const key = typeof meta.stepKey === 'string' ? meta.stepKey : meta?.key;
        if (!key) return false;
        return key.toLowerCase() === 'questionario';
      };

      const docIdFromMeta = (meta) => {
        if (!isQuestionarioStep(meta)) return '';
        const candidates = [meta.id, meta.questionarioDocId, meta.questionarioUid];
        return candidates.map(normalizeId).find(Boolean) || '';
      };

      const resolvedDocId =
        [
          docIdFromMeta(primaryMeta),
          docIdFromMeta(check?.initialMeta),
          docIdFromMeta(check?.meta)
        ].find(Boolean) || '';

      if (resolvedDocId) {
        query.questionarioDocId = resolvedDocId;
      }

      router.push({
        name: 'UserProgrammiQuestionario',
        params: { userId: props.userId },
        query
      });
    };

    const parseNumberLoose = (raw) => {
      if (raw === null || raw === undefined) return null;
      if (typeof raw === 'number') return Number.isFinite(raw) ? raw : null;
      if (typeof raw === 'string') {
        const normalized = raw.replace(/[^0-9.,+-]/g, '').replace(',', '.');
        if (!normalized) return null;
        const value = Number(normalized);
        return Number.isFinite(value) ? value : null;
      }
      return null;
    };

    const parseDateLoose = (value) => {
      if (!value) return null;
      if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
      if (typeof value === 'number') {
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return null;
        const direct = new Date(trimmed);
        if (!Number.isNaN(direct.getTime())) return direct;
        const parts = trimmed.split(/[/-]/);
        if (parts.length === 3) {
          let year;
          let month;
          let day;
          if (parts[0].length === 4) {
            year = Number(parts[0]);
            month = Number(parts[1]) - 1;
            day = Number(parts[2]);
          } else {
            day = Number(parts[0]);
            month = Number(parts[1]) - 1;
            year = Number(parts[2]);
            if (parts[2].length === 2) {
              year += year >= 70 ? 1900 : 2000;
            }
          }
          const date = new Date(year, month, day);
          if (!Number.isNaN(date.getTime())) return date;
        }
      }
      return null;
    };

    const formatDateBasic = (dateInput) => {
      const d = toDate(dateInput);
      if (!d) return '';
      const dd = d.getDate().toString().padStart(2, '0');
      const mm = (d.getMonth() + 1).toString().padStart(2, '0');
      const yy = d.getFullYear();
      return `${dd}/${mm}/${yy}`;
    };

    const measurementTrends = computed(() => {
      const map = new Map();

      const ensureSeries = (label) => {
        const key = (label || '').trim();
        if (!key) return null;
        if (!map.has(key)) map.set(key, []);
        return map.get(key);
      };

      const pushMeasurement = ({ label, value, date, sourceType, sourceId }) => {
        const series = ensureSeries(label);
        if (!series) return;
        const numericValue = parseNumberLoose(value);
        if (numericValue === null) return;
        const parsedDate = parseDateLoose(date) || toDate(date) || new Date();
        if (!parsedDate || Number.isNaN(parsedDate.getTime())) return;
        series.push({
          date: parsedDate,
          value: numericValue,
          sourceType,
          sourceId
        });
      };

      const processMeasurements = (rows, sourceType, sourceId) => {
        if (!Array.isArray(rows)) return;
        rows.forEach(row => {
          pushMeasurement({
            label: row?.caratteristica,
            value: row?.valore,
            date: row?.data,
            sourceType,
            sourceId
          });
        });
      };

      comparisonChecks.value.forEach(check => {
        const id = check.linkedQuestionnaireId || check.id;
        processMeasurements(check.measurementsOne, 'initial', id);
        processMeasurements(check.measurementsTwo, 'check', id);
      });

      checks.value
        .filter(check => (check.creationMode === 'automatic' || (!!check.linkedQuestionnaireId && check.creationMode !== 'manual')))
        .forEach(check => {
          const id = check.linkedQuestionnaireId || check.id;
          processMeasurements(check.measurementsOne, 'initial', id);
          processMeasurements(check.measurementsTwo, 'check', id);
        });

      const result = {};
      map.forEach((entries, label) => {
        const valid = entries
          .filter(entry => Number.isFinite(entry.value) && entry.date && !Number.isNaN(entry.date.getTime()))
          .sort((a, b) => a.date - b.date);
        if (!valid.length) return;
        const seen = new Map();
        const deduped = [];
        valid.forEach(entry => {
          const key = `${entry.sourceType || 'check'}_${entry.date.getTime()}_${entry.value}`;
          if (seen.has(key)) return;
          seen.set(key, true);
          deduped.push(entry);
        });
        result[label] = deduped;
      });

      return result;
    });

    const trendCharts = computed(() => {
      return TREND_CONFIGS.map(config => {
        const entries = measurementTrends.value[config.label];
        if (!entries || !entries.length) return null;

        const sorted = entries.map(entry => ({ ...entry })).sort((a, b) => a.date - b.date);
        const values = sorted.map(entry => entry.value);
        const min = Math.min(...values);
        const max = Math.max(...values);
        const range = max - min || 1;
        const paddingX = 8;
        const paddingY = 12;
        const width = 100 - paddingX * 2;
        const height = 100 - paddingY * 2;
        let checkCounter = 0;
        const points = sorted.map((entry, index) => {
          const ratioX = sorted.length === 1 ? 0.5 : index / (sorted.length - 1);
          const normalized = (entry.value - min) / range;
          const x = paddingX + ratioX * width;
          const y = paddingY + (1 - normalized) * height;
          let kindLabel = 'Check';
          let kindClass = 'check';
          if (entry.sourceType === 'initial') {
            kindLabel = 'Questionario iniziale';
            kindClass = 'initial';
          } else {
            checkCounter += 1;
            kindLabel = `Check ${checkCounter}`;
          }
          return {
            x,
            y,
            value: entry.value,
            valueLabel: formatMeasurement(entry.value),
            date: entry.date,
            dateLabel: formatDateBasic(entry.date),
            kindLabel,
            kindClass
          };
        });
        const polyline = points.length === 1
          ? (() => {
              const p = points[0];
              const offset = 5;
              const x1 = Math.max(paddingX, p.x - offset);
              const x2 = Math.min(100 - paddingX, p.x + offset);
              return `${x1},${p.y} ${x2},${p.y}`;
            })()
          : points.map(pt => `${pt.x},${pt.y}`).join(' ');
        const firstValue = sorted[0].value;
        const lastValue = sorted[sorted.length - 1].value;
        const delta = lastValue - firstValue;
        const deltaLabel = `${delta > 0 ? '+' : ''}${delta.toFixed(1)}${config.unit || ''}`;
        const deltaClass = delta > 0 ? 'positive' : delta < 0 ? 'negative' : 'neutral';
        return {
          label: config.label,
          color: config.color,
          unit: config.unit,
          points,
          polyline,
          min,
          max,
          minLabel: formatMeasurement(min),
          maxLabel: formatMeasurement(max),
          delta,
          deltaLabel,
          deltaClass,
          latestLabel: formatMeasurement(lastValue)
        };
      }).filter(Boolean);
    });

    watch(
      () => props.userId,
      (uid) => {
        subscribeChecks(uid || null);
        subscribeDafareChecks(uid || null);
        subscribeQuestionari(uid || null);
        subscribePercorsi(uid || null);
        loadUserWarning(uid || null);
        hideChecksSaving.value = false;
        resetCreateForm();
        showCreate.value = false;
        Object.keys(photoUploadFlags).forEach(key => delete photoUploadFlags[key]);
        Object.keys(measurementEditors).forEach(key => delete measurementEditors[key]);
        Object.keys(initialMeasurementEditors).forEach(key => delete initialMeasurementEditors[key]);
        Object.keys(approvalSaving).forEach(key => delete approvalSaving[key]);
      },
      { immediate: true }
    );

    watch(
      manualBaselinesByPercorso,
      () => {
        if (questionnaireDocs.value.length) {
          rebuildQuestionnaireComparisons();
        }
      },
      { deep: true }
    );

    watch(
      percorsi,
      () => {
        if (questionnaireDocs.value.length) {
          rebuildQuestionnaireComparisons();
        }
      },
      { deep: true }
    );

    onBeforeUnmount(() => {
      if (unsubscribeChecks) unsubscribeChecks();
      if (unsubscribeDafare) unsubscribeDafare();
      if (unsubscribeQuestionari) unsubscribeQuestionari();
      if (unsubscribePercorsi) unsubscribePercorsi();
      resetCreateForm();
    });

    const sortedDafareChecks = computed(() => dafareChecks.value.slice().sort(compareByDateDesc));

    const comparisonsLoading = computed(() => checksLoading.value || questionnaireLoading.value);
    const comparisonsError = computed(() => checksError.value || questionnaireError.value);

    return {
      checks,
      dafareChecks,
      sortedDafareChecks,
      checksLoading,
      checksError,
      formatDate,
      formatDateTime,
      formatMeasurement,
      updateDafareCheckField,
      photoComparisonsFor,
      hasMeasurements,
      hasPhotoComparison,
      measurementComparisonsFor,
      hasInitialMeasurements,
      manualHistoryChecks,
      comparisonChecks,
      comparisonsLoading,
      comparisonsError,
      trendCharts,
      showCreate,
      toggleCreate,
      createSaving,
      saveManualCheck,
      newCheckText,
      newMeasurementOneRaw,
      newMeasurementTwoRaw,
      newCheckType,
      newPercorsoId,
      newVisibilityProfile,
      hideChecksFromUser,
      hideChecksSaving,
      updateUserChecksVisibility,
      createPhotoSlots,
      onNewPhotoChange,
      removeNewPhoto,
      isDropZoneHovered,
      newDropZoneKey,
      existingDropZoneKey,
      onNewPhotoDragEnter,
      onNewPhotoDragLeave,
      onNewPhotoDragOver,
      onNewPhotoDrop,
      triggerNewPhotoInput,
      renderPercorsoLabel,
      percorsi,
      userWarning,
      resetCreateForm,
      manualPhotoPairs,
      supportsInitialDataEdits,
      handleExistingPhotoUpload,
      isPhotoUploading,
      onExistingPhotoDragEnter,
      onExistingPhotoDragLeave,
      onExistingPhotoDragOver,
      onExistingPhotoDrop,
      isCheckApprovalSaving,
      toggleCheckApproval,
      measurementEditors,
      openMeasurementEditor,
      closeMeasurementEditor,
      saveMeasurementEditor,
      initialMeasurementEditors,
      openInitialMeasurementEditor,
      closeInitialMeasurementEditor,
      saveInitialMeasurementEditor,
      openInitialQuestionnaire
    };
  }
};
</script>


<style scoped>

.new-check-card {
  margin-top: 24px;
  padding: 20px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 32px rgba(15, 23, 42, 0.08);
  border: 1px solid #e2e8f0;
}

.new-check-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.new-check-header h1 {
  margin: 0;
  font-size: 1.3rem;
  color: #0f172a;
}

.new-check-subtitle {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #64748b;
}

.new-check-toggle {
  border: none;
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: #fff;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.new-check-toggle:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.25);
}

.new-check-warning {
  margin: 0 0 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #fff8e1;
  color: #b45309;
  border: 1px solid #fcd34d;
  font-size: 0.9rem;
  font-weight: 600;
}

.new-check-form {
  display: grid;
  gap: 18px;
  margin-top: 12px;
}

.new-check-section h3 {
  margin: 0 0 10px;
  font-size: 1rem;
  color: #0f172a;
}

.photo-upload-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

.photo-upload-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 18px 16px;
  border: 2px dashed #cbd5f5;
  border-radius: 14px;
  background: #f8fafc;
  text-align: center;
  min-height: 220px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.photo-upload-box.is-hovered {
  border-color: #2563eb;
  background: #eff6ff;
}

.photo-preview-img {
  width: 100%;
  max-height: 180px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.15);
}

.photo-actions {
  display: flex;
  gap: 10px;
  margin-top: 6px;
}

.photo-upload-label {
  font-weight: 700;
  font-size: 1rem;
  color: #0f172a;
}

.photo-upload-hint {
  margin: 0;
  font-size: 0.85rem;
  color: #475569;
}

.photo-upload-or {
  font-size: 0.8rem;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.photo-hidden-input {
  display: none;
}

.measurement-textareas {
  display: grid;
  gap: 16px;
}

.measurement-textareas textarea {
  width: 100%;
  min-height: 120px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #cbd5f5;
  background: #f1f5f9;
  font-family: inherit;
  resize: vertical;
}

.measurement-textareas label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #0f172a;
  display: block;
  margin-bottom: 6px;
}

.new-check-fields {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.field label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  color: #0f172a;
}

.field select,
.field textarea {
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #cbd5f5;
  background: #f8fafc;
  font-size: 0.95rem;
}

.field textarea {
  min-height: 100px;
  resize: vertical;
}

.checkbox-field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.checkbox-field input {
  width: auto;
}

.visibility-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 45%, #f1f5f9 100%);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
}

.visibility-card__content {
  display: grid;
  gap: 6px;
}

.visibility-card__eyebrow {
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #64748b;
}

.visibility-card h3 {
  margin: 0;
  font-size: 1.05rem;
  color: #0f172a;
}

.visibility-card p {
  margin: 0;
  color: #475569;
  font-size: 0.95rem;
}

.visibility-card__status {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
}

.status-pill--on {
  background: #dcfce7;
  color: #15803d;
}

.status-pill--off {
  background: #fee2e2;
  color: #b91c1c;
}

.status-loading {
  font-size: 0.85rem;
  color: #64748b;
}

.switch {
  position: relative;
  width: 54px;
  height: 32px;
  flex-shrink: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.switch__track {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: #cbd5f5;
  transition: background 0.2s ease;
}

.switch__thumb {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.2);
  transition: transform 0.2s ease;
}

.switch input:checked + .switch__track {
  background: #0ea5e9;
}

.switch input:checked + .switch__track + .switch__thumb {
  transform: translateX(22px);
}

.switch input:focus-visible + .switch__track {
  outline: 2px solid #0ea5e9;
  outline-offset: 3px;
}

.switch input:disabled + .switch__track {
  background: #e2e8f0;
}

.switch input:disabled + .switch__track + .switch__thumb {
  box-shadow: none;
  background: #f1f5f9;
}

.new-check-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

.new-check-action {
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  border: 1px solid transparent;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.new-check-action.primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: #fff;
}

.new-check-action.primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.new-check-action.ghost {
  background: #f8fafc;
  color: #0f172a;
  border-color: #cbd5f5;
}

.new-check-action:hover:not(:disabled),
.new-check-toggle:hover {
  transform: translateY(-1px);
}

.new-check-action:active:not(:disabled),
.new-check-toggle:active {
  transform: translateY(0);
}

.new-check-action.ghost {
  align-self: flex-start;
}

.select-details {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem 1rem;
  margin-top: 1rem;
}

.select-details p {
  margin: 0.25rem 0;
}



.check-text {
  white-space: pre-wrap; /* mantiene esattamente gli spazi e i ritorni a capo */
}


.check-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 1rem;
  padding: 1rem;
  max-width: 96%;
}

.text-photos {
  margin-bottom: 1rem;
}

.photo-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  margin-top: 1rem;
}

.photo-pairs {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1rem;
}

.photo-pair__title {
  font-weight: 600;
  font-size: 1rem;
  color: #0f172a;
  margin-bottom: 0.5rem;
}

.photo-pair__columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.photo-slot {
  position: relative;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  padding: 14px 12px;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.photo-slot.is-hovered {
  border-color: #2563eb;
  background: #eff6ff;
}

.photo-slot-img {
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
}

.photo-slot-label {
  font-weight: 700;
  font-size: 0.95rem;
  color: #0f172a;
}

.photo-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  border-radius: 10px;
  background: #e2e8f0;
  color: #475569;
  font-weight: 600;
}

.photo-empty__link,
.questionnaire-link {
  border: none;
  background: transparent;
  color: #2563eb;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.photo-empty__link:hover,
.questionnaire-link:hover {
  color: #1d4ed8;
}

.comparison-placeholder {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px dashed #bfdbfe;
  border-radius: 12px;
  background: #eff6ff;
  text-align: center;
  display: flex;
  justify-content: center;
}

.comparison-placeholder--inner {
  margin-top: 0.75rem;
  justify-content: flex-start;
}

.photo-upload-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;
  border: none;
}

.photo-upload-button input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.photo-loading {
  font-size: 0.8rem;
  color: #2563eb;
}

.check-card img {
  max-width: 100%;
  border-radius: 10px;
}

/* Nuovo stile per posizionare le tabelle una accanto all'altra */
.measurements {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.measurements > div {
  flex: 1;
}

.measurements-wrapper {
  margin-top: 1rem;
  display: grid;
  gap: 14px;
}

.measurement-edit-actions {
  display: flex;
  justify-content: flex-end;
}

.measurement-editor {
  border: 1px solid #cbd5f5;
  border-radius: 12px;
  background: #f8fafc;
  padding: 14px;
  display: grid;
  gap: 12px;
}

.measurement-editor-grid {
  display: grid;
  gap: 12px;
}

.measurement-editor textarea {
  width: 100%;
  min-height: 100px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #cbd5f5;
  background: #ffffff;
  resize: vertical;
  font-family: inherit;
}

.measurement-editor label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #0f172a;
  margin-bottom: 6px;
  display: block;
}

.measurement-editor-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.measurement-hint {
  font-size: 0.75rem;
  color: #64748b;
  margin: 4px 0 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
}

table th,
table td {
  border: 1px solid #ddd;
  padding: 0.5rem;
}

table th {
  background-color: #eee;
}

.comparison-section {
  margin-top: 2rem;
}

.comparison-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
  display: grid;
  gap: 1.25rem;
}

.comparison-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}

.comparison-head h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #0f172a;
}

.comparison-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  font-size: 0.85rem;
  color: #64748b;
}

.comparison-photos {
  display: grid;
  gap: 1.5rem;
}

.photo-comparison h4 {
  margin: 0 0 0.75rem;
  font-size: 1rem;
  color: #1f2937;
}

.photo-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

.photo-col {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  border: 1px dashed rgba(59, 130, 246, 0.35);
  border-radius: 12px;
  padding: 0.75rem;
  display: grid;
  gap: 0.75rem;
  justify-items: center;
}

.photo-col--initial {
  padding: 1.2rem 1rem;
  min-height: 240px;
  border-style: dashed;
  transition: border-color 0.18s ease, background 0.18s ease;
}

.photo-col--initial.is-hovered {
  border-color: #2563eb;
  background: #eff6ff;
}

.photo-col-title {
  font-size: 0.78rem;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.photo-col-img {
  width: 100%;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
}

.photo-col img {
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
}

.photo-empty {
  font-size: 0.9rem;
  color: #94a3b8;
}

.comparison-measurements table {
  margin-top: 0;
  background: #f8fafc;
  border-radius: 10px;
  overflow: hidden;
}

.comparison-measurements th {
  background-color: #e2e8f0;
  color: #1f2937;
}

.comparison-measurements th span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.table-action-link {
  border: none;
  background: none;
  color: #2563eb;
  font-weight: 600;
  font-size: 0.75rem;
  cursor: pointer;
  text-transform: none;
  padding: 2px 6px;
  border-radius: 8px;
}

.table-action-link:hover:not(:disabled) {
  background: rgba(37, 99, 235, 0.12);
}

.table-action-link:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.comparison-measurements td {
  background-color: #ffffff;
}

.comparison-notes {
  display: grid;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #334155;
}

.comparison-notes strong {
  display: block;
  margin-bottom: 0.25rem;
  color: #1f2937;
}

.comparison-notes p {
  margin: 0.15rem 0;
}

.error-text {
  color: #dc2626;
}

.tag {
  display: inline-block;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  background: #e2e8f0;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tag + .tag {
  margin-left: 0.4rem;
}

.tag-auto {
  background: rgba(59, 130, 246, 0.18);
  color: #1d4ed8;
}

.tag-manual {
  background: rgba(16, 185, 129, 0.18);
  color: #047857;
}

.tag-link {
  background: rgba(234, 179, 8, 0.25);
  color: #92400e;
}

.tag-approved {
  background: rgba(16, 185, 129, 0.2);
  color: #047857;
}

.tag-pending {
  background: rgba(148, 163, 184, 0.25);
  color: #475569;
}

.check-approval {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0;
}

.check-approval strong {
  margin-right: 0.25rem;
}

.check-approval .muted {
  margin-left: auto;
  font-size: 0.75rem;
}

.approval-actions {
  margin: 0.5rem 0 1rem;
}

.trend-section {
  margin-top: 2rem;
}

.trend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
}

.trend-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  display: grid;
  gap: 1rem;
}

.trend-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.trend-card__head h3 {
  margin: 0 0 0.25rem;
  font-size: 1rem;
  color: #0f172a;
}

.trend-chart {
  position: relative;
  height: 100%;
}

.trend-chart svg {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(148, 163, 184, 0.08) 0%, rgba(226, 232, 240, 0.2) 100%);
  border-radius: 12px;
}

.trend-points {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.35rem;
}

.trend-points li {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #475569;
  align-items: center;
  gap: 0.5rem;
}

.trend-date {
  color: #94a3b8;
}

.trend-value {
  font-weight: 600;
  color: #0f172a;
}

.trend-kind {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.1rem 0.4rem;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.18);
  color: #475569;
}

.trend-kind--initial {
  background: rgba(14, 165, 233, 0.18);
  color: #0369a1;
}

.trend-kind--check {
  background: rgba(59, 130, 246, 0.15);
  color: #1d4ed8;
}

.trend-diff {
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.8rem;
}

.trend-diff.positive {
  background: rgba(34, 197, 94, 0.12);
  color: #15803d;
}

.trend-diff.negative {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
}

.trend-diff.neutral {
  background: rgba(148, 163, 184, 0.18);
  color: #475569;
}
</style>
